var _defs, _g, _g2, _g3, _g4, _g5, _rect, _path, _rect2, _path2, _rect3, _path3, _g6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 952.962,
    height: 655.347,
    viewBox: "0 0 952.962 655.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 72,
    y: 143,
    width: 402,
    height: 209,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4e5f6c",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 480,
    y: 0,
    width: 395,
    height: 236,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4e5f6c",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: -0.002,
    x2: 0.5,
    y2: 0.98,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ad193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2485ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.5,
    y1: 1.006,
    x2: 0.5,
    y2: 0.05,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2485ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ad193"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ac",
    x: 0,
    y: 381,
    width: 310,
    height: 211,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "ad"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4e5f6c",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "ad"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 0.379,
    y1: 0.94,
    x2: 0.375,
    y2: 0.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5c5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    y1: 0.508,
    x2: 1,
    y2: 0.508,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    y1: 0.501,
    y2: 0.501,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f9f9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f9f9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2382fa",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37a8ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9abff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9eaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fn",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gm",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hm",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ik",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jo",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kj",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#bx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ko",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr",
    x1: 0.5,
    y1: 0,
    x2: 0.696,
    y2: 0,
    xlinkHref: "#q"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-888 -144)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-186.128 142.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1074.13, 1.93)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 161,
    rx: 8,
    transform: "translate(96 164)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1243.864,304.341s43.178-43.159,63.99-50.588,37.5,18.052,47.477,20.377,24.87-6.595,33.877-4.872,12.276,7.571,17.729,0,33.489-62.753,39.708-67.563,10.555-15.1,28.294,11.168,38.923,61.268,38.923,61.268,20.53,21.352,32.616,3.1,12.87-23.479,12.87-23.479v51.3Z",
    transform: "translate(-44.637 4.373)",
    fill: "#2ad193",
    opacity: 0.289
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.24,311.856s24.408-23.66,38.7-35.233,36.582,13.212,36.582,13.212,24.834,24.078,42.97-8.328,34.593-65.167,65.782-59.178,58.521,52.415,88.611,30.086,42.6-32.522,42.6-32.522",
    transform: "translate(-45.777 -2.796)",
    fill: "none",
    stroke: "#0050d0",
    strokeWidth: 4,
    opacity: 0.989
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.687 -31.152)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 925.69, 175.15)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 188,
    rx: 8,
    transform: "translate(504 21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1452.458 217.594)",
    opacity: 0.859
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.768)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 35.313,
    transform: "translate(0 43.125)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 54.848,
    transform: "translate(24.231 23.59)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 25.17,
    transform: "translate(48.462 53.268)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 63.489,
    transform: "translate(72.693 14.949)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 78.438,
    transform: "translate(96.924)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 57.854,
    transform: "translate(121.155 20.584)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 46.584,
    transform: "translate(145.386 31.854)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 68.373,
    transform: "translate(169.617 10.065)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 57.854,
    transform: "translate(193.848 20.584)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 48.838,
    transform: "translate(218.079 29.6)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 39.219,
    transform: "translate(242.31 39.219)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 23.292,
    transform: "translate(266.541 55.146)",
    fill: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.768 78.438)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 43.203,
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 58.605,
    transform: "translate(24.231)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 32.684,
    transform: "translate(48.462)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 53.346,
    transform: "translate(72.693)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 64.616,
    transform: "translate(96.924)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 46.584,
    transform: "translate(121.155)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.004,
    height: 56.727,
    transform: "translate(145.386)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 66.495,
    transform: "translate(169.617)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 40.573,
    transform: "translate(193.848)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 53.346,
    transform: "translate(218.079)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 46.584,
    transform: "translate(242.31)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.005,
    height: 32.308,
    transform: "translate(266.541)",
    fill: "url(#q)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 301.292,
    height: 1.127,
    transform: "translate(0 77.874)",
    fill: "#2e2856"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 -221)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-993.018 610.456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1758.02, -245.46)",
    filter: "url(#ac)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 163,
    rx: 8,
    transform: "translate(24 402)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(846.229 790.881)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 116,
    transform: "translate(0.771 0.119)",
    fill: "#2ad193"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 82,
    transform: "translate(40.771 34.119)",
    fill: "#215ea8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 55,
    transform: "translate(80.771 61.119)",
    fill: "#2ad193"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    transform: "translate(120.771 88.119)",
    fill: "#215ea8"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.038 64.435)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.462,
    cy: 49.815,
    rx: 365.462,
    ry: 49.815,
    transform: "translate(1007 635.282)",
    fill: "#2485ff",
    opacity: 0.071
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.389,
    cy: 31.658,
    rx: 312.389,
    ry: 31.658,
    transform: "translate(1060.073 653.905)",
    fill: "#2485ff",
    opacity: 0.115
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3058 2)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4251.458 430.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.962,2.83H94.145A13.788,13.788,0,0,0,80.26,16.521V302.658h1.987V14.562a11.637,11.637,0,0,1,.138-1.779,2.706,2.706,0,0,1,.1-.575c.042-.187.083-.381.132-.568s.1-.374.159-.554a11.649,11.649,0,0,1,2.367-4.153c.125-.145.249-.284.381-.415a2.769,2.769,0,0,1,.2-.2,11.94,11.94,0,0,1,1.966-1.613c.242-.152.491-.3.741-.436A7.982,7.982,0,0,1,89.21,3.9h0l.561-.221h0a12.065,12.065,0,0,1,4.347-.81H521.935a11.967,11.967,0,0,1,5.655,1.384c.249.138.5.284.741.436s.623.422.928.651h0l.436.353h0c.215.18.422.374.623.575a2.765,2.765,0,0,1,.2.2c.132.131.256.27.381.415a11.538,11.538,0,0,1,2.9,7.655V302.658h2.007v-287A13.8,13.8,0,0,0,521.962,2.83Z",
    transform: "translate(-24.706 -0.871)",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.22,13.691A13.788,13.788,0,0,1,94.1,0H521.922a13.788,13.788,0,0,1,13.843,13.691v1.1A13.8,13.8,0,0,0,521.922,1.959H94.133A13.788,13.788,0,0,0,80.248,15.65Z",
    transform: "translate(-24.694 0.001)",
    fill: "url(#af)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 451.559,
    height: 8.015,
    transform: "translate(57.54 293.806)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.689,14.637V294.69H83.13V14.637A11.836,11.836,0,0,1,95,2.87H522.818a11.836,11.836,0,0,1,11.871,11.767Z",
    transform: "translate(-25.59 -0.883)",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.813,436.04v.734H80.26v-.734Z",
    transform: "translate(-24.706 -134.225)",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 281.042,
    height: 8.507,
    transform: "translate(0 302.971)",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 562.078,
    height: 0.422,
    transform: "translate(0 302.549)",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 281.042,
    height: 8.507,
    transform: "translate(281.042 302.971)",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 281.042,
    height: 8.002,
    transform: "translate(0 302.971)",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 281.042,
    height: 8.002,
    transform: "translate(281.042 302.971)",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.238,437.1a6.513,6.513,0,0,1-6.513,6.513H354.743a6.513,6.513,0,0,1-6.513-6.513Z",
    transform: "translate(-107.195 -134.551)",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.723 302.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.1,437.1a6.513,6.513,0,0,1-6.513,6.513H354.6A6.506,6.506,0,0,1,348.1,437.1h-.318v.491a6.513,6.513,0,0,0,6.513,6.506h67.6a6.507,6.507,0,0,0,6.513-6.506V437.1Z",
    transform: "translate(-347.78 -437.1)",
    fill: "url(#ao)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,450a250.769,250.769,0,0,0,61.043,7.5H501.035a250.729,250.729,0,0,0,61.043-7.5Z",
    transform: "translate(0 -138.522)",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 432.87,
    height: 267.836,
    transform: "translate(66.885 19.042)",
    fill: "#fcfdff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124.677,
    height: 10.954,
    transform: "translate(4325.493 459.905)",
    fill: "none",
    stroke: "#b2c6d9",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.328,22.519H25.042v7.606h89.286a3.8,3.8,0,1,0,0-7.606Z",
    transform: "translate(4302.125 439.06)",
    opacity: 0.872,
    fill: "url(#aq)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 124.677,
    height: 10.954,
    transform: "translate(4325.493 475.03)",
    fill: "none",
    stroke: "#b2c6d9",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.256,50.016H25.042v7.606H134.256a3.8,3.8,0,0,0,0-7.606Z",
    transform: "translate(4302.125 426.688)",
    opacity: 0.872,
    fill: "url(#aq)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 124.677,
    height: 10.954,
    transform: "translate(4325.493 490.156)",
    fill: "none",
    stroke: "#b2c6d9",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.255,77.513H25.042V85.12h98.213a3.8,3.8,0,0,0,0-7.607Z",
    transform: "translate(4302.125 414.316)",
    opacity: 0.872,
    fill: "url(#aq)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4321.491 669.037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.495,456.613v19.251h6.273V456.613a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-252.495 -433.731)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.649,450.961v25.5h6.273v-25.5a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-251.909 -434.093)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,442.279v34.736h6.272V442.279a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-251.322 -434.649)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.958,446.094v30.677h6.272V446.094a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-250.736 -434.405)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.112,456.613v19.251h6.273V456.613a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-250.149 -433.731)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.267,461.983v13.77h6.272v-13.77a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-249.563 -433.387)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.422,446.094v30.677h6.271V446.094a3.135,3.135,0,0,0-6.271,0Z",
    transform: "translate(-253.634 -434.405)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.576,442.279v34.736h6.272V442.279a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-253.823 -434.649)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.73,452.8v23.543H332V452.8a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-254.013 -433.975)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.885,459.157v16.777h6.271V459.157a3.135,3.135,0,0,0-6.271,0Z",
    transform: "translate(-254.203 -433.568)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.039,446.095v30.676h6.273V446.095a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-254.393 -434.405)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.193,463.317v12.351h6.273V463.317a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-254.582 -433.301)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.348,459.093v16.845h6.272V459.093a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-254.772 -433.572)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5,452.8v23.543h6.272V452.8a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-254.962 -433.975)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.657,448.575v28.037h6.272V448.575a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-255.152 -434.246)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.811,454.613v21.612h6.272V454.613a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-255.342 -433.859)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.966,461.606v14.171h6.271V461.606a3.135,3.135,0,0,0-6.271,0Z",
    transform: "translate(-255.531 -433.411)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.12,467.132v8.291h6.272v-8.291a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-255.721 -433.057)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.274,459.094v16.844h6.273V459.094a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-255.911 -433.572)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.429,452.8v23.543H432.7V452.8a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-256.101 -433.975)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.583,446.095v30.676h6.272V446.095a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-256.29 -434.405)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.737,438.055v39h6.273v-39a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-256.48 -434.92)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.892,444.093V476.9h6.272V444.093a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-256.67 -434.533)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.046,461.481v14.3h6.272v-14.3a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-256.86 -433.419)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.2,452.8v23.543h6.273V452.8a3.136,3.136,0,0,0-6.273,0Z",
    transform: "translate(-260.931 -433.975)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.355,456.613v19.251h6.271V456.613a3.136,3.136,0,0,0-6.271,0Z",
    transform: "translate(-260.344 -433.731)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.51,446.095v30.676h6.271V446.095a3.135,3.135,0,0,0-6.271,0Z",
    transform: "translate(-259.758 -434.405)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.664,440.442v36.691h6.272V440.442a3.136,3.136,0,0,0-6.272,0Z",
    transform: "translate(-259.171 -434.767)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.818,448.576v28.036h6.272V448.576a3.136,3.136,0,1,0-6.272,0Z",
    transform: "translate(-258.585 -434.246)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.973,456.613V476.1h6.271V456.613a3.135,3.135,0,0,0-6.271,0Z",
    transform: "translate(-257.998 -433.731)",
    fill: "url(#at)"
  })), /*#__PURE__*/React.createElement("line", {
    x2: 277.281,
    transform: "translate(0 42.366)",
    fill: "none",
    stroke: "#6a73c1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M337.73,43.688a15.4,15.4,0,1,1-15.4-15.4",
    transform: "translate(4175.298 436.465)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.627,44.156A14.831,14.831,0,1,1,322.8,29.325,14.831,14.831,0,0,1,337.627,44.156Z",
    transform: "translate(4174.831 435.997)",
    fill: "#b2c6d9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.162,59.09a15.4,15.4,0,1,1,0-30.8",
    transform: "translate(4142.528 436.465)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4520.641 463.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.593,86.384l-.352,0,.019-1.1.333,0Z",
    transform: "translate(-390.477 -52.286)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.9,86.294l-.077-1.1.266-.021.1,1.1Z",
    transform: "translate(-391.637 -52.238)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.937,86.262l-.285-.026.11-1.095.265.024Z",
    transform: "translate(-389.312 -52.223)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.4,85.994l-.174-1.086.266-.044.186,1.084Z",
    transform: "translate(-392.72 -52.098)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.365,85.93l-.28-.049.2-1.082.264.047Z",
    transform: "translate(-388.157 -52.069)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.869,85.485l-.259-1.069.258-.065.279,1.064Z",
    transform: "translate(-393.793 -51.867)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M399.83,85.39l-.277-.074.292-1.06.257.068Z",
    transform: "translate(-387.019 -51.824)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.29,84.769l-.349-1.043.254-.087.365,1.038Z",
    transform: "translate(-394.841 -51.547)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M397.353,84.644c-.091-.031-.182-.064-.272-.1l.381-1.032.25.09Z",
    transform: "translate(-385.906 -51.491)",
    fill: "url(#cf)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.64,83.854l-.434-1.01.244-.108.45,1Z",
    transform: "translate(-395.861 -51.14)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M394.944,83.695l-.261-.119.466-1,.243.111Z",
    transform: "translate(-384.827 -51.07)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.906,82.746l-.52-.97.234-.128.535.961Z",
    transform: "translate(-396.841 -50.651)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M392.627,82.554l-.249-.14.548-.954.234.131Z",
    transform: "translate(-383.79 -50.566)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.073,81.453l-.6-.924.222-.146.613.913Z",
    transform: "translate(-397.781 -50.082)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M390.419,81.23l-.237-.161.625-.9.221.149Z",
    transform: "translate(-382.802 -49.983)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.128,79.982l-.674-.87.211-.165.687.859Z",
    transform: "translate(-398.672 -49.436)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M388.333,79.73l-.221-.179.7-.851.208.169Z",
    transform: "translate(-381.87 -49.325)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.054,78.346l-.746-.81.2-.184.753.8Z",
    transform: "translate(-399.506 -48.718)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M386.383,78.069l-.206-.2.765-.791.194.185Z",
    transform: "translate(-381 -48.597)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429.842,76.561l-.8-.75c.06-.064.119-.13.178-.2l.82.733Q429.94,76.456,429.842,76.561Z",
    transform: "translate(-400.284 -47.937)",
    fill: "url(#cq)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M384.581,76.259c-.064-.071-.128-.143-.191-.215l.832-.72c.058.067.116.133.175.2Z",
    transform: "translate(-380.196 -47.806)",
    fill: "url(#cr)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.476,74.629l-.868-.675.163-.212.879.661Z",
    transform: "translate(-400.991 -47.093)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M382.943,74.31c-.059-.076-.116-.152-.173-.23l.888-.65c.052.071.105.141.158.212Z",
    transform: "translate(-379.467 -46.953)",
    fill: "url(#ct)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.945,72.57l-.921-.6.146-.226.929.589Z",
    transform: "translate(-401.628 -46.194)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.475,72.234c-.051-.081-.1-.162-.152-.243l.939-.573.141.225Z",
    transform: "translate(-378.816 -46.048)",
    fill: "url(#cv)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.238,70.4l-.968-.524.126-.236.977.506Z",
    transform: "translate(-402.188 -45.248)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M380.191,70.046l-.129-.251.982-.5.122.239Z",
    transform: "translate(-378.249 -45.094)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.347,68.125l-1.008-.442.105-.245,1.015.423Z",
    transform: "translate(-402.669 -44.257)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M379.1,67.765l-.108-.262,1.021-.412.1.247Z",
    transform: "translate(-377.768 -44.102)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.262,65.764l-1.042-.353.085-.256,1.046.338Z",
    transform: "translate(-403.065 -43.23)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M378.213,65.4l-.086-.27,1.051-.327.082.257Z",
    transform: "translate(-377.378 -43.073)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.972,63.34l-1.068-.263.063-.262,1.071.25Z",
    transform: "translate(-403.374 -42.177)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M377.531,62.973l-.063-.277,1.074-.236.06.262Z",
    transform: "translate(-377.082 -42.018)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.478,60.872l-1.086-.173.04-.263,1.089.154Z",
    transform: "translate(-403.593 -41.107)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M377.062,60.5l-.04-.283,1.091-.141.037.264Z",
    transform: "translate(-376.881 -40.944)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.774,58.366l-1.1-.077.018-.269,1.1.064Z",
    transform: "translate(-403.721 -40.02)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M376.809,57.991l-.016-.285,1.1-.051.014.266Z",
    transform: "translate(-376.778 -39.856)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.755,55.837l0-.266,1.1-.026,0,.286Z",
    transform: "translate(-403.755 -38.906)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M377.866,55.46l-1.1-.019.008-.286,1.1.039Z",
    transform: "translate(-376.766 -38.731)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,53.341l-.026-.268,1.094-.116.029.282Z",
    transform: "translate(-403.684 -37.742)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M378.017,52.966l-1.094-.115.031-.281,1.093.128Z",
    transform: "translate(-376.837 -37.568)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.283,50.861l-.049-.262,1.08-.212.052.282Z",
    transform: "translate(-403.522 -36.586)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M378.38,50.491l-1.081-.205.056-.281,1.076.225Z",
    transform: "translate(-377.005 -36.414)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.744,48.422l-.07-.257,1.058-.3.076.276Z",
    transform: "translate(-403.27 -35.451)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M378.948,48.058l-1.06-.294c.026-.092.052-.185.079-.276l1.054.315Z",
    transform: "translate(-377.271 -35.281)",
    fill: "url(#dp)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.006,46.04l-.092-.253,1.03-.385.1.266Z",
    transform: "translate(-402.928 -34.343)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M379.719,45.681l-1.031-.383q.05-.135.1-.269l1.024.4Z",
    transform: "translate(-377.631 -34.175)",
    fill: "url(#dr)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.081,43.731l-.113-.243.994-.471.119.256Z",
    transform: "translate(-402.502 -33.27)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M380.691,43.379l-1-.467.125-.259.987.486Z",
    transform: "translate(-378.084 -33.106)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.967,41.508q-.064-.115-.131-.229l.951-.554c.048.083.1.166.142.25Z",
    transform: "translate(-401.993 -32.239)",
    fill: "url(#du)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M381.853,41.168l-.953-.55c.048-.084.1-.166.147-.249l.941.57C381.942,41.014,381.9,41.091,381.853,41.168Z",
    transform: "translate(-378.626 -32.078)",
    fill: "url(#dv)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.681,39.4l-.153-.222.9-.631.161.232Z",
    transform: "translate(-401.405 -31.257)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M383.2,39.066l-.9-.628.164-.232.894.641Z",
    transform: "translate(-379.252 -31.105)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.225,37.392l-.169-.206.843-.706.182.222Z",
    transform: "translate(-400.743 -30.329)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M384.71,37.082l-.849-.7c.062-.074.123-.147.185-.22l.834.718C384.822,36.947,384.766,37.015,384.71,37.082Z",
    transform: "translate(-379.958 -30.186)",
    fill: "url(#dv)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.614,35.524l-.187-.193.784-.771.2.2Z",
    transform: "translate(-400.009 -29.465)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M386.382,35.238l-.786-.77.2-.2.778.778Z",
    transform: "translate(-380.738 -29.334)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.855,33.8l-.2-.176.718-.834.214.187Z",
    transform: "translate(-399.211 -28.667)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2,33.534l-.721-.83.218-.186.706.843Z",
    transform: "translate(-381.588 -28.546)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.963,32.227l-.215-.159.647-.89.229.17Z",
    transform: "translate(-398.354 -27.943)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M390.162,31.991l-.65-.888c.077-.057.155-.112.234-.168l.63.9Q390.268,31.913,390.162,31.991Z",
    transform: "translate(-382.501 -27.834)",
    fill: "url(#ef)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.954,30.825l-.229-.141.569-.941.242.149Z",
    transform: "translate(-397.444 -27.297)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M392.241,30.619l-.573-.94.244-.146.558.948Z",
    transform: "translate(-383.47 -27.203)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.833,29.6l-.24-.121.49-.985.255.129Z",
    transform: "translate(-396.485 -26.735)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M394.427,29.426l-.492-.984.253-.124.481.989Z",
    transform: "translate(-384.49 -26.656)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.622,28.561l-.247-.1.4-1.024.266.108Z",
    transform: "translate(-395.487 -26.26)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M396.706,28.42,396.3,27.4l.265-.1.392,1.028Z",
    transform: "translate(-385.554 -26.196)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.334,27.719l-.257-.079.316-1.054.273.085Z",
    transform: "translate(-394.453 -25.877)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M399.066,27.609l-.321-1.052.276-.081.3,1.058Z",
    transform: "translate(-386.655 -25.827)",
    fill: "url(#en)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.985,27.079l-.26-.057.228-1.076.278.061Z",
    transform: "translate(-393.394 -25.589)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M401.489,27l-.232-1.075c.094-.02.187-.039.282-.058l.21,1.08Z",
    transform: "translate(-387.785 -25.554)",
    fill: "url(#ep)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.6,26.647l-.266-.035.135-1.092.282.037Z",
    transform: "translate(-392.317 -25.398)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M403.955,26.6l-.138-1.092.281-.034.123,1.093Z",
    transform: "translate(-388.937 -25.377)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.18,26.422l-.266-.012.042-1.1.286.013Z",
    transform: "translate(-391.23 -25.303)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.449,26.406l-.048-1.1.285-.01.029,1.1Z",
    transform: "translate(-390.099 -25.297)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.461,44.156A14.831,14.831,0,1,1,395.63,29.325,14.831,14.831,0,0,1,410.461,44.156Z",
    transform: "translate(4142.061 435.997)",
    fill: "#b2c6d9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M468,59.09a15.4,15.4,0,1,1,0-30.8",
    transform: "translate(4109.759 436.465)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4560.705 463.107)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M480.427,86.384l-.352,0,.019-1.1.333,0Z",
    transform: "translate(-463.311 -52.286)",
    fill: "url(#bx)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M482.73,86.294l-.077-1.1.266-.021.1,1.1Z",
    transform: "translate(-464.471 -52.238)",
    fill: "url(#bx)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M477.771,86.262l-.285-.026.11-1.095.265.024Z",
    transform: "translate(-462.146 -52.223)",
    fill: "url(#bx)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M485.234,85.994l-.174-1.086.266-.044.186,1.084Z",
    transform: "translate(-465.554 -52.098)",
    fill: "url(#bx)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M475.2,85.93l-.28-.049.2-1.082.264.047Z",
    transform: "translate(-460.991 -52.069)",
    fill: "url(#bx)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M487.7,85.485l-.259-1.069.258-.065.279,1.064Z",
    transform: "translate(-466.627 -51.867)",
    fill: "url(#bx)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M472.664,85.39l-.277-.074.292-1.06.257.068Z",
    transform: "translate(-459.852 -51.824)",
    fill: "url(#bx)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M490.124,84.769l-.349-1.043.254-.087.365,1.038Z",
    transform: "translate(-467.675 -51.547)",
    fill: "url(#bx)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M470.187,84.644c-.091-.031-.182-.064-.272-.1l.381-1.032.25.09Z",
    transform: "translate(-458.74 -51.491)",
    fill: "url(#fc)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M492.474,83.854l-.434-1.01.244-.108.45,1Z",
    transform: "translate(-468.695 -51.14)",
    fill: "url(#bx)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M467.778,83.695l-.261-.119.466-1,.243.111Z",
    transform: "translate(-457.661 -51.07)",
    fill: "url(#bx)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M494.74,82.746l-.52-.97.234-.128.535.961Z",
    transform: "translate(-469.675 -50.651)",
    fill: "url(#bx)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M465.461,82.554l-.249-.14.548-.954.234.131Z",
    transform: "translate(-456.624 -50.566)",
    fill: "url(#bx)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M496.907,81.453l-.6-.924.222-.146.613.913Z",
    transform: "translate(-470.616 -50.082)",
    fill: "url(#bx)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M463.254,81.23l-.237-.161.625-.9.221.149Z",
    transform: "translate(-455.636 -49.983)",
    fill: "url(#bx)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M498.962,79.982l-.674-.87.21-.165.687.859Z",
    transform: "translate(-471.506 -49.436)",
    fill: "url(#bx)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M461.167,79.73l-.221-.179.7-.851.208.169Z",
    transform: "translate(-454.704 -49.325)",
    fill: "url(#bx)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M500.888,78.346l-.746-.81.2-.184.753.8Z",
    transform: "translate(-472.34 -48.718)",
    fill: "url(#bx)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M459.216,78.069l-.206-.2.765-.791.194.185Z",
    transform: "translate(-453.834 -48.597)",
    fill: "url(#bx)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M502.676,76.561l-.8-.75c.06-.064.119-.13.178-.2l.82.733Q502.774,76.456,502.676,76.561Z",
    transform: "translate(-473.118 -47.937)",
    fill: "url(#fn)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M457.415,76.259c-.064-.071-.128-.143-.191-.215l.832-.72c.058.067.116.133.175.2Z",
    transform: "translate(-453.03 -47.806)",
    fill: "url(#cr)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M504.31,74.629l-.868-.675.163-.212.879.661Z",
    transform: "translate(-473.825 -47.093)",
    fill: "url(#bx)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M455.777,74.31c-.059-.076-.116-.152-.173-.23l.888-.65c.052.071.105.141.158.212Z",
    transform: "translate(-452.301 -46.953)",
    fill: "url(#ct)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M505.779,72.57l-.921-.6.146-.226.929.589Z",
    transform: "translate(-474.462 -46.194)",
    fill: "url(#bx)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M454.309,72.234c-.051-.081-.1-.162-.152-.243l.939-.573.141.225Z",
    transform: "translate(-451.65 -46.048)",
    fill: "url(#cv)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M507.071,70.4l-.968-.524.126-.236.977.506Z",
    transform: "translate(-475.022 -45.248)",
    fill: "url(#bx)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M453.025,70.046l-.129-.251.982-.5.122.239Z",
    transform: "translate(-451.083 -45.094)",
    fill: "url(#bx)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M508.181,68.125l-1.008-.442.105-.245,1.015.423Z",
    transform: "translate(-475.503 -44.257)",
    fill: "url(#bx)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M451.935,67.765l-.108-.262,1.021-.412.1.247Z",
    transform: "translate(-450.602 -44.102)",
    fill: "url(#bx)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M509.1,65.764l-1.042-.353.085-.256,1.046.338Z",
    transform: "translate(-475.9 -43.23)",
    fill: "url(#bx)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M451.047,65.4l-.086-.27,1.051-.327.082.257Z",
    transform: "translate(-450.212 -43.073)",
    fill: "url(#bx)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M509.806,63.34l-1.068-.263.063-.262,1.071.25Z",
    transform: "translate(-476.207 -42.177)",
    fill: "url(#bx)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M450.365,62.973,450.3,62.7l1.074-.236.06.262Z",
    transform: "translate(-449.915 -42.018)",
    fill: "url(#bx)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M510.312,60.872l-1.086-.173.04-.263,1.089.154Z",
    transform: "translate(-476.427 -41.107)",
    fill: "url(#bx)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9,60.5l-.04-.283,1.092-.141.036.264Z",
    transform: "translate(-449.715 -40.944)",
    fill: "url(#bx)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M510.608,58.366l-1.1-.077.018-.269,1.1.064Z",
    transform: "translate(-476.555 -40.02)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.644,57.991l-.016-.285,1.1-.051.014.266Z",
    transform: "translate(-449.612 -39.856)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M509.589,55.837l0-.266,1.1-.026,0,.286Z",
    transform: "translate(-476.588 -38.906)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.7,55.46l-1.1-.019.008-.286,1.1.039Z",
    transform: "translate(-449.6 -38.731)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M509.454,53.341l-.026-.268,1.094-.116.029.282Z",
    transform: "translate(-476.518 -37.742)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.851,52.966l-1.094-.115.031-.281,1.093.128Z",
    transform: "translate(-449.671 -37.568)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M509.117,50.861l-.049-.262,1.08-.212.052.282Z",
    transform: "translate(-476.356 -36.586)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.214,50.491l-1.081-.205.056-.281,1.077.225Z",
    transform: "translate(-449.839 -36.414)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M508.578,48.422l-.07-.257,1.058-.3.076.276Z",
    transform: "translate(-476.104 -35.451)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.782,48.058l-1.06-.294c.026-.092.052-.185.079-.276l1.054.315Z",
    transform: "translate(-450.104 -35.281)",
    fill: "url(#gm)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M507.84,46.04l-.093-.253,1.03-.385.1.266Z",
    transform: "translate(-475.762 -34.343)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.553,45.681l-1.031-.383c.034-.09.068-.18.1-.269l1.024.4Z",
    transform: "translate(-450.464 -34.175)",
    fill: "url(#dr)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M506.915,43.731l-.113-.243.994-.471.119.256Z",
    transform: "translate(-475.336 -33.27)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M453.525,43.379l-1-.467.125-.259.987.486Z",
    transform: "translate(-450.918 -33.106)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M505.8,41.508c-.043-.076-.086-.153-.131-.229l.951-.554c.048.083.1.166.142.25Z",
    transform: "translate(-474.827 -32.239)",
    fill: "url(#gr)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.687,41.168l-.953-.55c.048-.084.1-.166.147-.249l.941.57C454.776,41.014,454.731,41.091,454.687,41.168Z",
    transform: "translate(-451.46 -32.078)",
    fill: "url(#dv)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M504.515,39.4l-.153-.222.9-.631.161.232Z",
    transform: "translate(-474.239 -31.257)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.03,39.066l-.9-.628.164-.232.894.641Z",
    transform: "translate(-452.086 -31.105)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M503.059,37.392l-.169-.206.843-.706.182.222Z",
    transform: "translate(-473.577 -30.329)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.544,37.082l-.849-.7c.062-.074.123-.147.185-.22l.834.718C457.656,36.947,457.6,37.015,457.544,37.082Z",
    transform: "translate(-452.792 -30.186)",
    fill: "url(#dv)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M501.448,35.524l-.187-.193.784-.771.2.2Z",
    transform: "translate(-472.843 -29.465)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M459.216,35.238l-.786-.77.2-.2.778.778Z",
    transform: "translate(-453.572 -29.334)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M499.689,33.8l-.2-.176.718-.834.214.187Z",
    transform: "translate(-472.045 -28.667)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.038,33.534l-.721-.83.218-.186.706.843Z",
    transform: "translate(-454.422 -28.546)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M497.8,32.227l-.215-.159.647-.89.229.17Z",
    transform: "translate(-471.188 -27.943)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463,31.991l-.65-.888c.077-.057.155-.112.234-.168l.63.9Q463.1,31.913,463,31.991Z",
    transform: "translate(-455.334 -27.834)",
    fill: "url(#ef)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M495.788,30.825l-.229-.141.569-.941.242.149Z",
    transform: "translate(-470.278 -27.297)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.075,30.619l-.573-.94.244-.146.558.948Z",
    transform: "translate(-456.305 -27.203)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M493.667,29.6l-.24-.121.49-.985.255.129Z",
    transform: "translate(-469.319 -26.735)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.261,29.426l-.492-.984.252-.124.481.989Z",
    transform: "translate(-457.324 -26.656)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M491.456,28.561l-.247-.1.4-1.024.266.108Z",
    transform: "translate(-468.321 -26.26)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M469.54,28.42l-.408-1.022.265-.1.392,1.028Z",
    transform: "translate(-458.388 -26.196)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M489.168,27.719l-.257-.079.316-1.054.273.085Z",
    transform: "translate(-467.287 -25.877)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.9,27.609l-.321-1.052c.092-.028.183-.055.276-.081l.3,1.058Z",
    transform: "translate(-459.489 -25.827)",
    fill: "url(#en)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M486.819,27.079l-.26-.057.228-1.076.278.061Z",
    transform: "translate(-466.228 -25.589)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M474.323,27l-.232-1.075c.093-.02.187-.039.281-.058l.211,1.08Z",
    transform: "translate(-460.619 -25.554)",
    fill: "url(#hm)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M484.431,26.647l-.266-.035.135-1.092.281.037Z",
    transform: "translate(-465.151 -25.398)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.789,26.6l-.138-1.092.281-.034.122,1.093Z",
    transform: "translate(-461.771 -25.377)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M482.014,26.422l-.266-.012.042-1.1.286.013Z",
    transform: "translate(-464.064 -25.303)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M479.283,26.406l-.048-1.1.285-.01.029,1.1Z",
    transform: "translate(-462.933 -25.297)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M483.295,44.156a14.831,14.831,0,1,1-14.831-14.831A14.831,14.831,0,0,1,483.295,44.156Z",
    transform: "translate(4109.291 435.997)",
    fill: "#b2c6d9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4480.577 463.107)"
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M334.759,86.384l-.352,0,.019-1.1.333,0Z",
    transform: "translate(-317.643 -52.286)",
    fill: "url(#bx)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M337.062,86.294l-.077-1.1.266-.021.1,1.1Z",
    transform: "translate(-318.803 -52.238)",
    fill: "url(#bx)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M332.1,86.262l-.285-.026.11-1.095.265.024Z",
    transform: "translate(-316.479 -52.223)",
    fill: "url(#bx)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M339.566,85.994l-.174-1.086.266-.044.186,1.084Z",
    transform: "translate(-319.886 -52.098)",
    fill: "url(#bx)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M329.531,85.93l-.28-.049.2-1.082.264.047Z",
    transform: "translate(-315.323 -52.069)",
    fill: "url(#bx)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M342.035,85.485l-.259-1.069.258-.065.279,1.064Z",
    transform: "translate(-320.959 -51.867)",
    fill: "url(#bx)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M327,85.39l-.277-.074.292-1.06.257.068Z",
    transform: "translate(-314.185 -51.824)",
    fill: "url(#bx)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M344.455,84.769l-.349-1.043.254-.087.365,1.038Z",
    transform: "translate(-322.007 -51.547)",
    fill: "url(#bx)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M324.519,84.644c-.091-.031-.181-.064-.272-.1l.381-1.032.25.09Z",
    transform: "translate(-313.072 -51.491)",
    fill: "url(#cf)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M346.806,83.854l-.434-1.01.244-.108.45,1Z",
    transform: "translate(-323.027 -51.14)",
    fill: "url(#bx)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M322.11,83.695l-.261-.119.466-1,.243.111Z",
    transform: "translate(-311.993 -51.07)",
    fill: "url(#bx)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M349.072,82.746l-.52-.97.234-.128.535.961Z",
    transform: "translate(-324.007 -50.651)",
    fill: "url(#bx)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M319.793,82.554l-.249-.14.548-.954.234.131Z",
    transform: "translate(-310.956 -50.566)",
    fill: "url(#bx)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M351.239,81.453l-.6-.924.222-.146.613.913Z",
    transform: "translate(-324.948 -50.082)",
    fill: "url(#bx)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M317.586,81.23l-.237-.161.625-.9.221.149Z",
    transform: "translate(-309.968 -49.983)",
    fill: "url(#bx)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M353.294,79.982l-.674-.87.211-.165.687.859Z",
    transform: "translate(-325.838 -49.436)",
    fill: "url(#bx)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M315.5,79.73l-.221-.179.7-.851.208.169Z",
    transform: "translate(-309.036 -49.325)",
    fill: "url(#bx)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M355.22,78.346l-.746-.81.2-.184.753.8Z",
    transform: "translate(-326.672 -48.718)",
    fill: "url(#bx)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M313.549,78.069l-.206-.2.765-.791.194.185Z",
    transform: "translate(-308.166 -48.597)",
    fill: "url(#bx)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M357.008,76.561l-.8-.75c.06-.064.119-.13.178-.2l.82.733Q357.106,76.456,357.008,76.561Z",
    transform: "translate(-327.45 -47.937)",
    fill: "url(#ik)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M311.747,76.259c-.064-.071-.128-.143-.191-.215l.832-.72c.058.067.116.133.176.2Z",
    transform: "translate(-307.362 -47.806)",
    fill: "url(#cr)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M358.642,74.629l-.868-.675.163-.212.879.661Z",
    transform: "translate(-328.157 -47.093)",
    fill: "url(#bx)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M310.109,74.31q-.087-.114-.173-.23l.888-.65c.052.071.105.141.158.212Z",
    transform: "translate(-306.633 -46.953)",
    fill: "url(#ct)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M360.111,72.57l-.921-.6.146-.226.929.589Z",
    transform: "translate(-328.794 -46.194)",
    fill: "url(#bx)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M308.641,72.234c-.051-.081-.1-.162-.152-.243l.939-.573.141.225Z",
    transform: "translate(-305.982 -46.048)",
    fill: "url(#cv)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M361.4,70.4l-.968-.524.126-.236.977.506Z",
    transform: "translate(-329.354 -45.248)",
    fill: "url(#bx)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M307.357,70.046l-.129-.251.982-.5.122.239Z",
    transform: "translate(-305.415 -45.094)",
    fill: "url(#bx)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M362.513,68.125l-1.008-.442.105-.245,1.015.423Z",
    transform: "translate(-329.835 -44.257)",
    fill: "url(#bx)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M306.267,67.765l-.108-.262,1.021-.412.1.247Z",
    transform: "translate(-304.934 -44.102)",
    fill: "url(#bx)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M363.428,65.764l-1.042-.353.085-.256,1.046.338Z",
    transform: "translate(-330.231 -43.23)",
    fill: "url(#bx)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M305.379,65.4l-.086-.27,1.051-.327.082.257Z",
    transform: "translate(-304.544 -43.073)",
    fill: "url(#bx)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M364.138,63.34l-1.068-.263.063-.262,1.071.25Z",
    transform: "translate(-330.539 -42.177)",
    fill: "url(#bx)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M304.7,62.973l-.063-.277,1.074-.236.06.262Z",
    transform: "translate(-304.247 -42.018)",
    fill: "url(#bx)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M364.644,60.872l-1.086-.173.04-.263,1.089.154Z",
    transform: "translate(-330.759 -41.107)",
    fill: "url(#bx)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M304.228,60.5l-.04-.283,1.092-.141.036.264Z",
    transform: "translate(-304.047 -40.944)",
    fill: "url(#bx)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M364.94,58.366l-1.1-.077.018-.269,1.1.064Z",
    transform: "translate(-330.887 -40.02)",
    fill: "url(#bx)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M303.976,57.991l-.016-.285,1.1-.051.014.266Z",
    transform: "translate(-303.944 -39.856)",
    fill: "url(#bx)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M363.921,55.837l0-.266,1.1-.026,0,.286Z",
    transform: "translate(-330.92 -38.906)",
    fill: "url(#bx)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M305.032,55.46l-1.1-.019.008-.286,1.1.039Z",
    transform: "translate(-303.932 -38.731)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.786,53.341l-.026-.268,1.094-.116.029.282Z",
    transform: "translate(-330.85 -37.742)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M305.183,52.966l-1.094-.115.031-.281,1.093.128Z",
    transform: "translate(-304.003 -37.568)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.449,50.861,363.4,50.6l1.08-.212.052.282Z",
    transform: "translate(-330.688 -36.586)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M305.546,50.491l-1.081-.205.056-.281,1.077.225Z",
    transform: "translate(-304.171 -36.414)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.91,48.422l-.07-.257,1.058-.3.076.276Z",
    transform: "translate(-330.436 -35.451)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M306.114,48.058l-1.06-.294c.026-.092.052-.185.079-.276l1.054.315Z",
    transform: "translate(-304.437 -35.281)",
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.172,46.04l-.092-.253,1.03-.385.1.266Z",
    transform: "translate(-330.094 -34.343)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M306.885,45.681l-1.031-.383q.05-.135.1-.269l1.024.4Z",
    transform: "translate(-304.796 -34.175)",
    fill: "url(#dr)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.247,43.731l-.113-.243.994-.471.119.256Z",
    transform: "translate(-329.668 -33.27)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M307.857,43.379l-1-.467.125-.259.987.486Z",
    transform: "translate(-305.25 -33.106)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.133,41.508q-.064-.115-.131-.229l.951-.554c.048.083.1.166.142.25Z",
    transform: "translate(-329.159 -32.239)",
    fill: "url(#jo)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M309.019,41.168l-.953-.55c.048-.084.1-.166.147-.249l.941.57Q309.086,41.052,309.019,41.168Z",
    transform: "translate(-305.792 -32.078)",
    fill: "url(#dv)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.847,39.4l-.153-.222.9-.631.161.232Z",
    transform: "translate(-328.571 -31.257)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M310.362,39.066l-.9-.628.164-.232.894.641Z",
    transform: "translate(-306.418 -31.105)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.391,37.392l-.169-.206.843-.706.182.222Z",
    transform: "translate(-327.909 -30.329)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M311.876,37.082l-.849-.7c.062-.074.123-.147.185-.22l.834.718C311.988,36.947,311.932,37.015,311.876,37.082Z",
    transform: "translate(-307.124 -30.186)",
    fill: "url(#dv)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.78,35.524l-.187-.193.784-.771.2.2Z",
    transform: "translate(-327.175 -29.465)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M313.548,35.238l-.786-.77.2-.2.778.778Z",
    transform: "translate(-307.905 -29.334)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.021,33.8l-.2-.176.718-.834.214.187Z",
    transform: "translate(-326.377 -28.667)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M315.37,33.534l-.721-.83.218-.186.706.843Z",
    transform: "translate(-308.754 -28.546)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.129,32.227l-.215-.159.647-.89.229.17Z",
    transform: "translate(-325.52 -27.943)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M317.328,31.991l-.65-.888c.077-.057.155-.112.234-.168l.63.9Q317.434,31.913,317.328,31.991Z",
    transform: "translate(-309.666 -27.834)",
    fill: "url(#ef)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.12,30.825l-.229-.141.569-.941.242.149Z",
    transform: "translate(-324.61 -27.297)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M319.407,30.619l-.573-.94.244-.146.558.948Z",
    transform: "translate(-310.637 -27.203)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348,29.6l-.24-.121.49-.985.255.129Z",
    transform: "translate(-323.651 -26.735)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M321.593,29.426l-.492-.984.253-.124.481.989Z",
    transform: "translate(-311.656 -26.656)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.788,28.561l-.247-.1.4-1.024.266.108Z",
    transform: "translate(-322.653 -26.26)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M323.872,28.42l-.408-1.022.265-.1.392,1.028Z",
    transform: "translate(-312.72 -26.196)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,27.719l-.257-.079.316-1.054.273.085Z",
    transform: "translate(-321.619 -25.877)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M326.232,27.609l-.321-1.052c.092-.028.183-.055.276-.081l.3,1.058Z",
    transform: "translate(-313.821 -25.827)",
    fill: "url(#en)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.151,27.079l-.261-.057.228-1.076.278.061Z",
    transform: "translate(-320.56 -25.589)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M328.655,27l-.232-1.075c.093-.02.187-.039.282-.058l.21,1.08Z",
    transform: "translate(-314.951 -25.554)",
    fill: "url(#kj)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.763,26.647l-.266-.035.135-1.092.281.037Z",
    transform: "translate(-319.483 -25.398)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M331.121,26.6l-.137-1.092.281-.034.123,1.093Z",
    transform: "translate(-316.103 -25.377)",
    fill: "url(#bx)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.347,26.422l-.266-.012.042-1.1.286.013Z",
    transform: "translate(-318.396 -25.303)",
    fill: "url(#bx)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M333.615,26.406l-.048-1.1.285-.01.029,1.1Z",
    transform: "translate(-317.265 -25.297)",
    fill: "url(#bx)"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M335.928,51.787a5.5,5.5,0,1,1-5.5-5.5A5.5,5.5,0,0,1,335.928,51.787Z",
    transform: "translate(4167.199 428.366)",
    fill: "#c9eaff"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M331.807,45.859a7.675,7.675,0,1,1-7.662-8.033h0v-5.5h0a13.181,13.181,0,1,0,13.172,13.534Z",
    transform: "translate(4173.48 434.648)",
    opacity: 0.565,
    fill: "url(#ko)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M408.763,51.787a5.5,5.5,0,1,1-5.5-5.5A5.5,5.5,0,0,1,408.763,51.787Z",
    transform: "translate(4134.429 428.366)",
    fill: "#c9eaff"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M397.046,53.182c-.023,0-.044,0-.067,0a7.68,7.68,0,0,1,0-15.36c.023,0,.044,0,.067,0v-5.5l-.067,0a13.181,13.181,0,0,0,0,26.361l.067,0Z",
    transform: "translate(4140.711 434.648)",
    opacity: 0.565,
    fill: "url(#ko)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M481.6,51.787a5.5,5.5,0,1,1-5.5-5.5A5.5,5.5,0,0,1,481.6,51.787Z",
    transform: "translate(4101.66 428.366)",
    fill: "#c9eaff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M462.145,45.732c0-.076-.011-.15-.011-.227a7.688,7.688,0,0,1,7.68-7.68v-5.5a13.2,13.2,0,0,0-13.18,13.18c0,.076,0,.151.006.227Z",
    transform: "translate(4107.941 434.648)",
    opacity: 0.565,
    fill: "url(#ko)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4454.549 462.007)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.383,
    y: 0
  }, "A"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4454.549 476.811)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.382,
    y: 0
  }, "B"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4454.549 491.614)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.366,
    y: 0
  }, "C"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4497.172 481.351)",
    fill: "#2768e1",
    fontSize: 4,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.532,
    y: 0
  }, "A"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4537.201 481.351)",
    fill: "#2768e1",
    fontSize: 4,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.53,
    y: 0
  }, "B"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4577.265 481.351)",
    fill: "#2768e1",
    fontSize: 4,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.466,
    y: 0
  }, "C"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4491.514 499.821)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.108,
    y: 0
  }, "75%"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4532.95 500.821)",
    fill: "#fff",
    fontSize: 2,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.301,
    y: 0
  }, "50%"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(4572.212 499.821)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.101,
    y: 0
  }, "25%"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4607.508 534.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.122,402.339a1.436,1.436,0,1,1-1.436-1.436A1.436,1.436,0,0,1,611.122,402.339Z",
    transform: "translate(-568.023 -399.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.04,400.113a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,697.04,400.113Z",
    transform: "translate(-586.65 -398.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.246,458.643V420.687c-11.787.369-16.346-27.686-30.034-18.227-9.445,6.657-9.822,30.936-25.31,24.279-2.645-1.175-4.156-4.308-7.177-3.916-2.645.783-4.156,4.919-5.289,6.266-4,4.759-8.689,1.175-11.333-3.916-3.4-5.874-6.045-25.062-14.355-22.713-7.933,2.35-8.31,18.8-15.866,23.888-6.424,4.439-16.561,1.689-22.994-3.26v35.556Z",
    transform: "translate(-557.321 -400.511)",
    fill: "#2ad193",
    opacity: 0.259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.246,420.687c-11.787.369-16.346-27.686-30.034-18.227-9.445,6.657-9.822,30.936-25.31,24.279-2.645-1.175-4.156-4.308-7.177-3.916-2.645.783-4.156,4.919-5.289,6.266-4,4.759-8.689,1.175-11.333-3.916-3.4-5.874-6.045-25.062-14.355-22.713-7.933,2.35-8.31,18.8-15.866,23.888-6.424,4.439-16.561,1.689-22.994-3.26",
    transform: "translate(-557.321 -400.511)",
    fill: "none",
    stroke: "#2485ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.926,429.185a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,559.926,429.185Z",
    transform: "translate(-556.924 -406.416)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.872,435.785a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,578.872,435.785Z",
    transform: "translate(-561.031 -407.847)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.455,439.452a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,636.455,439.452Z",
    transform: "translate(-573.515 -408.642)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.623,428.435A1.436,1.436,0,1,1,648.187,427,1.436,1.436,0,0,1,649.623,428.435Z",
    transform: "translate(-576.37 -406.253)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.2,435.076a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,664.2,435.076Z",
    transform: "translate(-579.531 -407.693)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.924,425.976a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,728.924,425.976Z",
    transform: "translate(-593.563 -405.72)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.34,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(25.62 62.3)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.298,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(53.773 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.531,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(76.065 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.671,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(95.223 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.63,
    y: 0
  }, "25")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(113.597 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.673,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132.379 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.626,
    y: 0
  }, "35"))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4607.508 648.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.122,402.339a1.436,1.436,0,1,1-1.436-1.436A1.436,1.436,0,0,1,611.122,402.339Z",
    transform: "translate(-568.023 -399.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.04,400.113a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,697.04,400.113Z",
    transform: "translate(-586.65 -398.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.246,458.643V420.687c-11.787.369-16.346-27.686-30.034-18.227-9.445,6.657-9.822,30.936-25.31,24.279-2.645-1.175-4.156-4.308-7.177-3.916-2.645.783-4.156,4.919-5.289,6.266-4,4.759-8.689,1.175-11.333-3.916-3.4-5.874-6.045-25.062-14.355-22.713-7.933,2.35-8.31,18.8-15.866,23.888-6.424,4.439-16.561,1.689-22.994-3.26v35.556Z",
    transform: "translate(-557.321 -400.511)",
    fill: "#2ad193",
    opacity: 0.259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.246,420.687c-11.787.369-16.346-27.686-30.034-18.227-9.445,6.657-9.822,30.936-25.31,24.279-2.645-1.175-4.156-4.308-7.177-3.916-2.645.783-4.156,4.919-5.289,6.266-4,4.759-8.689,1.175-11.333-3.916-3.4-5.874-6.045-25.062-14.355-22.713-7.933,2.35-8.31,18.8-15.866,23.888-6.424,4.439-16.561,1.689-22.994-3.26",
    transform: "translate(-557.321 -400.511)",
    fill: "none",
    stroke: "#2485ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.926,429.185a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,559.926,429.185Z",
    transform: "translate(-556.924 -406.416)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.872,435.785a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,578.872,435.785Z",
    transform: "translate(-561.031 -407.847)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.455,439.452a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,636.455,439.452Z",
    transform: "translate(-573.515 -408.642)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.623,428.435A1.436,1.436,0,1,1,648.187,427,1.436,1.436,0,0,1,649.623,428.435Z",
    transform: "translate(-576.37 -406.253)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.2,435.076a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,664.2,435.076Z",
    transform: "translate(-579.531 -407.693)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.924,425.976a1.436,1.436,0,1,1-1.436-1.436A1.437,1.437,0,0,1,728.924,425.976Z",
    transform: "translate(-593.563 -405.72)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.34,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(25.62 62.3)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.298,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(53.773 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.531,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(76.065 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.671,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(95.223 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.63,
    y: 0
  }, "25")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(113.597 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.673,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132.379 62.457)",
    fill: "#fff",
    fontSize: 1,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.075em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.626,
    y: 0
  }, "35"))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4325.493 532.105)",
    opacity: 0.633
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.125,216.44q-.419-.982-1.384-.424l-.347.539A1.668,1.668,0,0,0,139.125,216.44Z",
    transform: "translate(-81.708 -205.578)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,223.51a2.162,2.162,0,0,1,1.462-.616,4.532,4.532,0,0,0-3.384-.691,3.507,3.507,0,0,0,.384,1.23Z",
    transform: "translate(-82.191 -205.919)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.864,220.382a3.88,3.88,0,0,0,3.922.114,1.979,1.979,0,0,0,2.655-.538l-.115-.616c-3.079.551-6,.045-7.884-1.73a6.9,6.9,0,0,0-1.616.077,4.171,4.171,0,0,0,.692,1.537l-.344.616a2.807,2.807,0,0,0,1.153.923A1.736,1.736,0,0,0,139.864,220.382Z",
    transform: "translate(-81.677 -205.674)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.561,212.642a12.278,12.278,0,0,1,2.769.424,9.474,9.474,0,0,0-1.768.423,4.941,4.941,0,0,0,3.732,1.192l.268-.308c.414-.009.546-.324.5-.806l.577.229a1.385,1.385,0,0,0,1.384-1.191c-.808-.007-1.384-.35-1.5-1.078l-.463-.269c.111.075-4.626-2.3-4.5-1.538,1.4.341.085.43-.73.5q.616.108.538.654a2.18,2.18,0,0,0-1.039.039l.115.5-.385.231v.461l.5.039Z",
    transform: "translate(-81.528 -205.242)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.089,215.885a1.039,1.039,0,0,0-1.231-.308l.115.423A1.579,1.579,0,0,0,130.089,215.885Z",
    transform: "translate(-81.248 -205.561)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,215.3c.429.087.685-.053.769-.423-.8-.369-1.484-.666-2.308-1l-.346.27a2.045,2.045,0,0,1,.54,1.116A2.425,2.425,0,0,0,134.4,215.3Z",
    transform: "translate(-81.445 -205.474)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.825,251.69a4.01,4.01,0,0,0-1.846-.462C159.675,251.64,160.144,252.7,160.825,251.69Z",
    transform: "translate(-82.87 -207.485)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.8,224.372a2.766,2.766,0,0,0-1.345-1.271c.946-.813.38-1.237-.768-1.422l-.078.424a2.205,2.205,0,0,0-1.386-.04,1.024,1.024,0,0,0,.618.885c-.317.849-.92.718-1.578.308l-.077.421a17.866,17.866,0,0,1,2.846,1.809C132.566,225.486,133.5,224.7,133.8,224.372Z",
    transform: "translate(-81.265 -205.894)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.892,222.392a3.841,3.841,0,0,1,1.23,1l.423-.308.153-.576A1.331,1.331,0,0,0,125.892,222.392Z",
    transform: "translate(-81.088 -205.916)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,212.482l.461-.194a.883.883,0,0,0-1.191-.691v.461h.576Z",
    transform: "translate(-81.362 -205.349)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.436,219.769l.153.423C128.558,219.846,128.243,219.748,127.436,219.769Z",
    transform: "translate(-81.171 -205.791)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,222.166l-.461.039-.269.269.539.077Z",
    transform: "translate(-81.022 -205.921)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.817,217.5a3.5,3.5,0,0,0,2.077.767c.488-1.281-.607-1.463-2-1.268Z",
    transform: "translate(-81.515 -205.639)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.384,215.7c-.907-.248-1.712-.095-2.038.654a8.287,8.287,0,0,0,2.038-.271Z",
    transform: "translate(-81.543 -205.566)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.29,220.011a1.364,1.364,0,0,1-.846-.731,1.489,1.489,0,0,0-1.423.769C134.915,220.866,135.766,220.989,136.29,220.011Z",
    transform: "translate(-81.526 -205.765)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07,220.742l-.309.348h.539Z",
    transform: "translate(-81.458 -205.844)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.261,283.422l.117.386.344-.038.193-.5a79.252,79.252,0,0,0-8.384-5.577,24.208,24.208,0,0,0,1.5-3.844,30.387,30.387,0,0,0-5.615,2.461A7.746,7.746,0,0,1,130.185,269a4.61,4.61,0,0,1,4.27-1.807,1.3,1.3,0,0,0,1.614.462.9.9,0,0,1,.078-1c3.3-.413,5.262,1.021,6.153,4.154l.386.115c-1.131-3.816.026-6.819,3.652-8.731a3.154,3.154,0,0,0-.807-1.23.552.552,0,0,0-.154-.886l.539-.269.461.616a13.5,13.5,0,0,0,1.27-2.654,10.027,10.027,0,0,0,2.461-.463c-.516-1.132-.284-1.982.923-2.154l.192-.421a6.539,6.539,0,0,1,3.422-.917c-1.452-.117-.887,1.559-.922,1.608a7.876,7.876,0,0,0,4-2.961c-1.545,1.4-2.91,1.216-3.884-.884a.878.878,0,0,0,.615-1.308,7.079,7.079,0,0,0-5.154,2.576,4.926,4.926,0,0,1,1.232-1.5l-.886-.231h1.116a1.486,1.486,0,0,1,1.615-1.077,37.124,37.124,0,0,0,8.5-2.615l-.346-.307a.909.909,0,0,0,.269-.961l-.807-.115-.154-.384c-.82.17-1.735.374-2.422.537a6.66,6.66,0,0,1,2.345-1.345,4.449,4.449,0,0,1-3.345-1.923,9.836,9.836,0,0,0-1.962-4,1.367,1.367,0,0,0-.692,1.577,3.478,3.478,0,0,1-1.885.73c-.163-.709-.61-.942-1.308-.654a6.162,6.162,0,0,0,.154-2.461,6.255,6.255,0,0,1-3.192-1.73,11.831,11.831,0,0,0-3.153.462,22.726,22.726,0,0,0,.691,2.692h-.538a.79.79,0,0,1-.308,1.077c1.976,1.743,1.7,3.181-.808,4.037,1.115,1.685,1.069,3.087-.692,3.768a4.588,4.588,0,0,1-1.269-4c-2.534-.677-5.043-1.334-7.346-1.924-2.395-2.538-2.092-4.889,1.039-6.729a3.3,3.3,0,0,0-1.579-.967,11.223,11.223,0,0,0,2.079.16l.115-.577a1.457,1.457,0,0,0,1.461.191,5.754,5.754,0,0,1,.576-1.268,5.115,5.115,0,0,1-2.768-.886,2.959,2.959,0,0,0,3.539-.268l-.5-.463a.845.845,0,0,1,1.115.422,2.879,2.879,0,0,0-.655,2.347l-.693.23.193.462.73.039v.423q1.045.329,1.231-.616c.922.082,1.765.192,2.654.345l.077-.576a.875.875,0,0,1-1.077-.884,7.335,7.335,0,0,1-2.231-.808v-.422l.616.114a.423.423,0,0,0,.192-.654h.73c.388-.5.774-.956,1.193-1.422a2.656,2.656,0,0,1-.731-1.231l.655-.114.191-.577a4.869,4.869,0,0,0-2.077-1.346h1l.115-.308a4.436,4.436,0,0,0,2.846.232l-.615-.577.423-.115c3.085,1.256,4.733,3.046,3.309,5.691l.344.693c-1.515-.341-2.713-.04-3.228,1.192a15.86,15.86,0,0,1,8.843,3l.077-.46a7.29,7.29,0,0,1-2.076-1.847q1.529.732,3,1.576a1.212,1.212,0,0,1,.423-1.307,1.012,1.012,0,0,1-.847-1.346,3.75,3.75,0,0,1-2.115-1.577,8.734,8.734,0,0,1,.768-.654,14.1,14.1,0,0,0,2.732,2,2.359,2.359,0,0,1,1.115-1.5h.539a.862.862,0,0,0,.192-.962h-1.077a2.661,2.661,0,0,0-2.345-1.189,3.862,3.862,0,0,0-.347-.808,6.288,6.288,0,0,1-1.308-.04v-.653a.79.79,0,0,0,1-.308l-.885-.23q.055-.443.538-.346a1.484,1.484,0,0,0-1.192-.654l.27-.423a1.816,1.816,0,0,0-1.538-.271l-.115-.345a2.113,2.113,0,0,1-.922-.115l.537-.347a1.585,1.585,0,0,0-1.654,0,1.12,1.12,0,0,1-.692-.961l-.577-.039-.037-.422a3.372,3.372,0,0,0-2.116-.309.963.963,0,0,1-1.346.309l-.193.422-.577.039a.86.86,0,0,1,.308-1.038,2.8,2.8,0,0,1-.847-1.307c-1.8-.073-2.942.449-2.461,2.075l-.308.424.616.807c-1.757-.788-1.86-2-.271-3.346-2.369-.211-3.675.932-3.651,3.308a1.726,1.726,0,0,1,1.768.692,1.738,1.738,0,0,0-1.423.077c1.155.452,2.182.8,3.537,1.193l-.653.192a.626.626,0,0,0,.422.923,19.515,19.515,0,0,1-1.614,2.344,1.075,1.075,0,0,1-.885-1.115l.385-.536-.961-.847-.769.653a4.3,4.3,0,0,0-1.461-1.345,1.961,1.961,0,0,0-.078-1.308l-.5-.078c-.114-.959-.78-1.395-1.808-1.269l-.153.386c-.449-.07-.731.149-.846.653a.674.674,0,0,1,.114.885,5.245,5.245,0,0,0,1.5,1.078l-.231.575-.806-.153.23.654a1.652,1.652,0,0,0,1.461-.5v.694l-1.345.693.115,1-.847-.537.231-.694h-.538l-.038-.653h.5q.177-1.426-1.386-1.537a.988.988,0,0,1-.922,1l1.115.731a1.131,1.131,0,0,0-.73.96,7.684,7.684,0,0,1-4.884-1.037,6.994,6.994,0,0,1-1.769.885,1.606,1.606,0,0,1,.114,1.653c-1.273-1.54-3.146-2.023-5.384-1.653l-.038-.348.886-.307a11.077,11.077,0,0,0-7.423-1.308l-.577-.962-.384.848c-.719-.477-1.374-.917-2.116-1.424a5.2,5.2,0,0,1-3.5,2.154c.841-.588,1.7-1.133,2.538-1.616-5.84,2.123-10.367-.335-16.461-.423l-.23-.539a11.538,11.538,0,0,0-2.384,0l.191-.422a24.02,24.02,0,0,0-8.115,3.077l-.268.768A8.631,8.631,0,0,1,83,232.2a2.614,2.614,0,0,1-1.653-.037l-.078-.655a8.57,8.57,0,0,0-2.731,1.346,1.91,1.91,0,0,1,1.269,1.5c1.306-.163,2.58-.358,3.769-.577a3.814,3.814,0,0,0-.154,1.576,14.854,14.854,0,0,1-2.538.271,1.921,1.921,0,0,1-1.154,1.693l.194.577.422.077a1.617,1.617,0,0,0,1.539,1.537l.5-.577a1.4,1.4,0,0,1,.461,1.847,2.9,2.9,0,0,1,2.229.077l.309-.539.5.424.615-.347a11.353,11.353,0,0,1-6.115,4.654l.5.231a47.672,47.672,0,0,0,8.269-4.615l-.577-.846a3.4,3.4,0,0,1,3.307-1.616c-1.187.137-1.663.737-1.345,1.769a6.389,6.389,0,0,1,2.577-.922l-.232-.5a32.213,32.213,0,0,1,9.038,2.5,3.9,3.9,0,0,0,1.847,1.113l-.154.5.845.348-.153.46a2.749,2.749,0,0,0,1.077.271c.249.791.51,1.561.807,2.384l.694.076a23.99,23.99,0,0,1,4.479,5.014,4.415,4.415,0,0,0-1.6-1.283l-.078-.615a5.624,5.624,0,0,0-2.153-.5c4.35,4.24,6.227,13.692,10.23,19.538l-.462.345a22.3,22.3,0,0,1,3.654,4.115,33.984,33.984,0,0,0-3.576-7.192,60.2,60.2,0,0,1,7.307,8.346.661.661,0,0,0-.538.73c4.574,2.706,8.551,3.353,12.845,5.538l.039-.384a3.11,3.11,0,0,1,1.693,2.46l.269.308c.339.027,2.039,1,2.153.885q.864.467,1.769.847C142.769,283.4,143.23,283.089,144.261,283.422Z",
    transform: "translate(-78.537 -205.915)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.091,225.951l.654-.539a26.556,26.556,0,0,1,4.961-2.884,9.518,9.518,0,0,0-6.577-1.422,3.272,3.272,0,0,1-1.115,3.461A2.029,2.029,0,0,1,113.091,225.951Z",
    transform: "translate(-80.287 -205.859)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,243.813a2.426,2.426,0,0,0,1.27-1.039v-.692a9.238,9.238,0,0,1-1.616,1Z",
    transform: "translate(-79.082 -206.993)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,230a2.365,2.365,0,0,1,1.23-.422l.039-.5a5.19,5.19,0,0,0-2.038.768Z",
    transform: "translate(-81.009 -206.293)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,240l.115.461a.971.971,0,0,0,.961-.116l-.232-.537A.748.748,0,0,0,78.9,240Z",
    transform: "translate(-78.557 -206.868)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.571,230.623l-.308-.577a1.324,1.324,0,0,0-1.73.694l.346.5A1.3,1.3,0,0,0,150.571,230.623Z",
    transform: "translate(-82.308 -206.34)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.518,249.926c-.115.021-.212-.056-.307,0a10.149,10.149,0,0,0-1.923,3.462c1.64-.359,2.182.326,3.462.923a4.772,4.772,0,0,0,.46-2.078,15.476,15.476,0,0,1-2.152-.922C165.332,250.493,165.647,250.7,165.518,249.926Z",
    transform: "translate(-83.102 -207.415)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,237.635l.231.769a1.215,1.215,0,0,0,1.076-.154,3.041,3.041,0,0,0-.075-.847A1.13,1.13,0,0,0,146.3,237.635Z",
    transform: "translate(-82.187 -206.737)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,237.763c.685,0,1.022-.4.924-.922-.435.218-.869.453-1.309.693C143.91,237.609,143.988,237.763,144.16,237.763Z",
    transform: "translate(-82.051 -206.711)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.233,216.855l.423-.192a1.892,1.892,0,0,0-1.115-1A1.1,1.1,0,0,0,127.233,216.855Z",
    transform: "translate(-81.122 -205.57)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.216,218.946c-.127.6-1.768-.216-3.73-1.077a2.727,2.727,0,0,0-1.846,2.039c1.53.077,2.937.1,4.461.077a8.659,8.659,0,0,1-2,.462,6.946,6.946,0,0,0,6.192-1.577.562.562,0,0,0-.731-.307l-.077.347a1.749,1.749,0,0,1-1.422-1.538,2.253,2.253,0,0,0-1.231.383A1.262,1.262,0,0,1,123.216,218.946Z",
    transform: "translate(-80.643 -205.662)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,216.525a2.548,2.548,0,0,0,1.462-.5l-.385-.346a.524.524,0,0,0,.654-.385,3.589,3.589,0,0,0-2.537.461Q121.1,216.535,121.78,216.525Z",
    transform: "translate(-80.823 -205.547)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.014,214.773h2.731A1.788,1.788,0,0,0,121.014,214.773Z",
    transform: "translate(-80.825 -205.488)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.017,214.379h-.655l.231.423a.53.53,0,0,1,.73.231,3.894,3.894,0,0,1,3.117.655c-.561-1.958-2.326-2.76-4.654-2.31l.268.387C127.6,213.631,127.944,213.829,128.017,214.379Z",
    transform: "translate(-81.136 -205.441)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.176,219.325l.731.115.384-.768-.73.193Z",
    transform: "translate(-80.565 -205.732)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.573,218.852l.307-.384.461.306a.5.5,0,0,0,.5-.539l.5-.037a.827.827,0,0,1,.576-.769l.347.5.384-.155a1.589,1.589,0,0,0,1.077-1.461c-.95.029-1.677.07-2.731.154a2.74,2.74,0,0,1-2.462,1.653A.983.983,0,0,0,114.573,218.852Z",
    transform: "translate(-80.422 -205.605)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.346,215.824l-.079-.5a1.063,1.063,0,0,0-.961-.194A.842.842,0,0,0,120.346,215.824Z",
    transform: "translate(-80.733 -205.539)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.834,217.126l.079.307.846.078-.039-.385S119.873,217.28,119.834,217.126Z",
    transform: "translate(-80.762 -205.649)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.334,217.522c1.545,1.538.444,1.049-.808.385a2.271,2.271,0,0,0,.192.96,5.3,5.3,0,0,0-2.038-1.538,2.016,2.016,0,0,0,2,2,3.552,3.552,0,0,1,.847-.23,1.709,1.709,0,0,1,.577,1.039,4.177,4.177,0,0,1,1.5-.308c.436-1.207.394-2.03-.923-1.845A1.333,1.333,0,0,0,130.334,217.522Z",
    transform: "translate(-81.184 -205.66)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.771,211.77q-.422-.013-.845-.009c-.521.084-2.048.524-2.192,1.116.491.161.45.262.5.73.6-.187,1.591-.2,1.923.384,1.1-.024,1.733.247,2.192-.617a.435.435,0,0,1-.384-.077c.165-1.768.089-1.076-1.384-1.076C284.711,212.008,284.81,212.019,284.771,211.77Z",
    transform: "translate(-89.483 -205.36)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.116,217.03v.191a2.7,2.7,0,0,1,.809,0C283.836,216.4,283.617,216.928,283.116,217.03Z",
    transform: "translate(-89.557 -205.63)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.634,215.643a9.4,9.4,0,0,0,3.961-1.537h-.652c0-1.205-1-.288-1.425-.5.188-.188.26-.189.308-.423a2.556,2.556,0,0,0-2.5,2.192C286.413,215.413,286.539,215.643,286.634,215.643Z",
    transform: "translate(-89.73 -205.436)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.118,211.388a.96.96,0,0,1,.617-.885c-.417-.2-.138-.464-1.154-.115,0-1.189-1.695-.038-2.347-.038,0,.81-.593.431-.922.884a7.651,7.651,0,0,0,1.23.577C282.056,212.082,283.528,211.437,284.118,211.388Z",
    transform: "translate(-89.406 -205.257)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.648,227.32c-1.322-.235-2.322-.9-2.423-2.115a2.88,2.88,0,0,0-2.731-2.23,2.368,2.368,0,0,0,.5,1.73,5.138,5.138,0,0,1-2.27-1.538,1.858,1.858,0,0,0,.384.771h-.653l-.039.306-.539.079q.122-.39.27-.77a6.309,6.309,0,0,0-1.615-.192l-.077.423-.462-.077c-.5-1.321-1.738-.853-3.077.153l.114.538-.654.384.04.309a.586.586,0,0,1,.769.307,1.487,1.487,0,0,1,1.768.076,3.116,3.116,0,0,0-1.692.654,26.123,26.123,0,0,1,4.076.538c-.2-.051-2.8.633-3.538.731l.538.768q.883.055,1.768.039c1.557,1.437,3.542,1.255,5.384-.154a2.872,2.872,0,0,0,3.461.192l-.537-.423A1.137,1.137,0,0,0,129.648,227.32Z",
    transform: "translate(-80.575 -205.96)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.513,215.469c-.009-.049.019-.107,0-.153a1.06,1.06,0,0,0-1.307-.308l.037.153A5.365,5.365,0,0,0,292.513,215.469Z",
    transform: "translate(-89.993 -205.53)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.422,222.914c-.165-.839-.982-.245-1.346.115.068.039.107.115.192.115A3.258,3.258,0,0,0,264.422,222.914Z",
    transform: "translate(-88.478 -205.938)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.579,209.648c-.3,0-.267.063-.577,0a.4.4,0,0,0-.116.462C279.544,210.183,280.211,209.648,279.579,209.648Z",
    transform: "translate(-89.328 -205.246)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.629,219.538a.655.655,0,0,1,0-.461C313.774,218.958,314.21,219.855,314.629,219.538Z",
    transform: "translate(-91.228 -205.754)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.165,220.783a1.413,1.413,0,0,1,.154-.538c.765.484,2.691-.031,3.692-.038,0-.487.272-.629.347-1.039-.742-.121-1.693-.6-1.693.634a1.262,1.262,0,0,0-.462,0,4.568,4.568,0,0,0,.192-1.057,5.448,5.448,0,0,0-.921,0v.423c-1.157-.094-1.226-.538-2.539-.538.04.485-.225.839-.307,1.308l-.114-.114A2.153,2.153,0,0,0,317.165,220.783Z",
    transform: "translate(-91.302 -205.73)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.623,220.086a7.507,7.507,0,0,0,3.269.307c-.013-.146-.008-.366-.008-.5-.553-.027-1.1.028-1.644.028v-.414c-.634-.026-1.08.459-1.5-.268l-.153.076v.655C322.643,220,322.557,220.057,322.623,220.086Z",
    transform: "translate(-91.683 -205.763)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,226.13c-1.527-1.377-2.187.314-2.73.181A13.427,13.427,0,0,0,350.76,226.13Z",
    transform: "translate(-93.054 -206.105)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.889,210.17c-.859-.343-1.63.359-2.422.114C258.657,211.4,258.684,210.39,259.889,210.17Z",
    transform: "translate(-88.176 -205.269)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,222.969c-.568-1.121-1.538-1.143-2.653-.27C318.685,222.852,319.492,222.748,320.4,222.969Z",
    transform: "translate(-91.423 -205.916)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.519,222.217h.691a6.457,6.457,0,0,0-1-.9A2.087,2.087,0,0,1,314.519,222.217Z",
    transform: "translate(-91.232 -205.875)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.52,221.695a.2.2,0,0,0,.191-.23,2.855,2.855,0,0,0-.923-.191C317.789,221.734,318.112,221.695,318.52,221.695Z",
    transform: "translate(-91.425 -205.872)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,212.547c.5.056,1.905.758,1.557-.308-.057,0-.106.039-.154.039-.508,0-.872-.29-1.4-.192A2.423,2.423,0,0,1,279.8,212.547Z",
    transform: "translate(-89.379 -205.376)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.186,213.9c.281.565.22,1,1.02,1a1.221,1.221,0,0,1,0-.462c1.2.1.74.361,1.9,0a.778.778,0,0,1-.039-.384l.308-.039c.181.273.156.156.191.577a.765.765,0,0,0,.885-.231q.294.122.154.462c0-.268-2.186.8-2.309.922.5-.1,2.064-.46,2.27-.191-2.323,1.463-1.858-.122-.23,2.037l.153-.039c.081-.416.791-1.461,1.289-1.461v-.768a.59.59,0,0,0,.6-.193,1.733,1.733,0,0,1-.1-.787h1.1a5.889,5.889,0,0,0-.077.672c1.205,0,.27.723.27,1.27.54-.339,1.269-.677,1.269.153.438.117.581-.04.692-.384a2.47,2.47,0,0,0,1.194-.077c-.141-.511-.437-.413-.9-.442a1.55,1.55,0,0,1,0-.52h-.981c0-1.453-1.872-1.205-2.626-1.577v-.461a.686.686,0,0,1-.6,0,4.26,4.26,0,0,0,.27-.615c-1.177.637-2.218,1.233-2.347,0-.51.19-.946.336-1.5.5-.054-.375.1-.422.385-.54l-.038-.153a21.038,21.038,0,0,0-2.192.5c.05.635.412.577.922.654a5.371,5.371,0,0,1-.039,1.271C217.642,214.383,217.7,214,217.186,213.9Z",
    transform: "translate(-86.006 -205.382)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,211.068a1.732,1.732,0,0,1-.462-1.095,3.292,3.292,0,0,1-1.154.306c0,.453-.31.316-.537.693A4.338,4.338,0,0,0,257.06,211.068Z",
    transform: "translate(-88.038 -205.264)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.119,241.96c-.048.009-.183.069-.23.079a1.373,1.373,0,0,0-.808.885A1.124,1.124,0,0,0,204.119,241.96Z",
    transform: "translate(-85.246 -206.987)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.493,228.3c0,.369.014.639.039,1.076.413,0,1.227-.23,1.306-.693-.3-.054-.336-.093-.383-.383Z",
    transform: "translate(-87.585 -206.251)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.406,212.339h-1.153v.346a5.274,5.274,0,0,0,5.423-.654,1.269,1.269,0,0,0-1.384-.191c-.042-.353-.2-.368-.383-.655-.449.167-.55.611-1.079.462.411-.208.317-.309.269-.578a1.124,1.124,0,0,1-1,.116,1.985,1.985,0,0,1-.192.846l-.154-.039c0-1.209-2.618-.934-2.268-.152C223.755,212.477,225.129,211.623,225.406,212.339Z",
    transform: "translate(-86.343 -205.323)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.367,222.056c-1.454-.76-2.743-.7-3.615.385a4.374,4.374,0,0,0,.231,1.96l.73-.116a.72.72,0,0,0,.577-.883A1.832,1.832,0,0,0,138.367,222.056Z",
    transform: "translate(-81.564 -205.887)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.288,209.611a3.758,3.758,0,0,0,3.938.2,1.016,1.016,0,0,0-.476,1.111,7.48,7.48,0,0,0,5.114-1.423,7.4,7.4,0,0,1,1.846-.192,3.083,3.083,0,0,0-1.692.767,5.06,5.06,0,0,1,1.576.078,32.3,32.3,0,0,1-4.383.846v.385a9.106,9.106,0,0,0,2.076.846c-1.525-.41-3.085-.778-4.731-1.116l-.077.423a5.482,5.482,0,0,0,3.693,1.769.9.9,0,0,0-.654.884,3.081,3.081,0,0,0-3.576-.307,3.1,3.1,0,0,0,.037.73,5.3,5.3,0,0,0,2.116.038l-.654.347a.988.988,0,0,0,1.149.421,3.988,3.988,0,0,1-3.457-.306c.519.9.091,1.316-.73,1.576a1.435,1.435,0,0,0,1.961.616,31.207,31.207,0,0,0,3.924-.04c.568,1.446,2.182-.165,2.462-.846l-.617.27-.192-.577.654-.115a.743.743,0,0,0-.037-1.038c.988-.352,2.422-.387,2.422-1.077,0-1.469-2.066-.282-2.462-.271l-.154-.383.617-.156a24.527,24.527,0,0,1,3.19-.575l-.692-.5a3.688,3.688,0,0,0,2.422.04.859.859,0,0,0-.807-.73,18.971,18.971,0,0,0,5.653-2l-.307-.386a4.9,4.9,0,0,1-2.615.271,24.624,24.624,0,0,1,5-.962c.444-1.025-.235-1.091-1.154-.884a2.779,2.779,0,0,0-3.191-.386l.038-.345a10.36,10.36,0,0,1-2.767-.5c-.839.135-3.6.727-4.193.886a5.391,5.391,0,0,0-1.846-.423l-.037.308a2.463,2.463,0,0,0-2.693.692,2.522,2.522,0,0,1,2.5.924,26.964,26.964,0,0,0-4.924-1.154,4.114,4.114,0,0,1-3.114,1.038l-.078.306-.769-.037-.04.345a3.136,3.136,0,0,1,.771.154Z",
    transform: "translate(-81.716 -205.056)",
    fill: "#2485ff",
    opacity: 0.554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.821,248.894c.068-.633.1-1.239.115-2,.545-.078.16-1.782-1-.886-.277-.22-.314-.377-.75-.268a2.1,2.1,0,0,0,.059.768,3.887,3.887,0,0,1-1.1.115v1.1a1.453,1.453,0,0,0,.519,0v.48C200.09,248.365,202.148,249.442,203.821,248.894Z",
    transform: "translate(-85.139 -207.189)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.309,243.689c-.121.378-.562.993-.538,1.232a1.409,1.409,0,0,1,1.079.229.357.357,0,0,1,.076-.307c.271.289.42.722-.076.884a.276.276,0,0,0,.114.307h.77l.078-.153c.426.343.137.745.653,1-.193.7-.8.961-1.614.961l-.041.154a5.071,5.071,0,0,0,.771.078c0,.324-.416.589-.73.616-.074.214.012.261.076.46.474-.075,1.271-.182,1.615.154a3.966,3.966,0,0,1-1.461.538c0,.452-.1.534-.5.693.069.02.078.115.154.115.674,0,.708-.372,1.463-.231a1.98,1.98,0,0,1,.037-.414c1.836.163,3.307.1,3.576-1.47h.308a.912.912,0,0,0-.731-.923c-.035.24-.044.2-.231.423-.374-.15-.265-.516-.307-.884h-.461c.134-1.209-1.412-1.766-2.154-2.384.176-.3.25-.408.578-.462a3.891,3.891,0,0,0,.345-1.308h-1.5c.217-.366.249-.681.655-.923-.3-.29-1-.1-1.386-.144,0,.45-.173.719-.173,1.183C204.238,243.145,203.083,243.469,204.309,243.689Z",
    transform: "translate(-85.283 -206.984)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.425,212.028a.272.272,0,0,0-.115-.307c-.047.01-.1.027-.153.038a2.21,2.21,0,0,1-.617.116C254.643,212.406,255,212.105,255.425,212.028Z",
    transform: "translate(-88.018 -205.358)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.538,211.191a6.572,6.572,0,0,0-2.194.422v.346c.747.205.7-.034.963-.383,0,.551.235.439.6.383a2.5,2.5,0,0,0,0-.461h.673A.653.653,0,0,0,254.538,211.191Z",
    transform: "translate(-87.9 -205.329)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.079,210.778c-.175-1.152.8-.23,1.461-.269a3.284,3.284,0,0,0,0-.537,5.715,5.715,0,0,1-.96,0c.2-.3.407-.4.46-.732-.675,0-1.152.072-1.152.77-.818,0-1.3-.151-1.193.761A4.44,4.44,0,0,1,253.079,210.778Z",
    transform: "translate(-87.864 -205.224)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.684,210.866v-.008c-.061.009-.124.017-.185.029Z",
    transform: "translate(-87.854 -205.311)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.425,224.995a.6.6,0,0,1,.308.345.243.243,0,0,0,.153-.307,2.287,2.287,0,0,1,.731.577c-.418.25-.275.32-.193.576.892.089,1.8.173,2.693.173-.04-.407-.192-.5-.192-.865-3.067-.7,1.151-3.757,1.306-4.731.572,0,2.071-.522,2-1.27,1.809-.148,3.978-1.575,5.575-1.575.32-.929-6.012.137-6.537,1.037-.776-.062-2.153.26-2.153,1.155a2.748,2.748,0,0,0-.845,0c.106.186-.2.883-.233,1.229-.495.059-1.549,0-1.346.77.266-.05.336-.147.617-.115-.118.342-.1.188.038.461-.115,0-.307.087-.422.078a.772.772,0,0,0-.5,0v.5a1,1,0,0,0-.692.115c.069.4-.082.5-.154.886-.749,0-.748.5-.748,1.152l.4.038A.2.2,0,0,1,249.425,224.995Z",
    transform: "translate(-87.71 -205.672)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.019,211.561a2.7,2.7,0,0,1,1.392-.672,2.2,2.2,0,0,0-1.544.555Z",
    transform: "translate(-87.766 -205.313)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.251,210.939c.084.389-.112.385-.463.385.522.95,1.043,1.087,1.384-.039.732-.04,1.182.1,1.346-.692a1.562,1.562,0,0,0-.423-.039v-.462c-.685-.111-.7.385-1.462.385-.563,0-.685.167-1.269,0-.256.444-.668.46-1.231.192C244.193,211.5,245.615,210.939,246.251,210.939Z",
    transform: "translate(-87.457 -205.269)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.324,327.393a3.777,3.777,0,0,0,1.866,2.231.918.918,0,0,0,0-.539h.635c.038-.746.251-.929.251-1.653C323.594,327.376,321.276,327.092,321.324,327.393Z",
    transform: "translate(-91.615 -211.582)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,286.878c-.941.083-1.378.59-1.116,1.578.289-.719.232-.82,1.23-.769a1.723,1.723,0,0,0,1.5,1.461c-.077-.414-.191-.573-.268-1,.326-.089.47.02.767-.154C306.88,284.291,306.2,287.665,305,286.878Z",
    transform: "translate(-90.672 -209.371)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.847,283c.623.44,1.94,1.324,2,2.172h.634c0-.862-.791-1.836-1.1-2.508C304.768,282.66,304.457,283,303.847,283Z",
    transform: "translate(-90.674 -209.179)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.438,286.054c0-.918.729-1.252.729-2.308-.562,1.149-2.037,2.194-2.345,3.116C300.652,286.862,300.553,286.054,301.438,286.054Z",
    transform: "translate(-90.457 -209.238)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.1,295.9c-.043.463.215.645.692.575a.49.49,0,0,0-.076-.422Z",
    transform: "translate(-90.849 -209.892)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.582,291.333v.806c-.594-.055-.806.145-1.345-.307a.645.645,0,0,0-.308.038c0,3.2,1.466,4.422,4.846,4.422.241-.919.581-1.458.808-2.5h.461v-.806c.448,0,.717.079.923-.346a1.329,1.329,0,0,0-.769-.192,14.483,14.483,0,0,1-.191-2.1,1.64,1.64,0,0,0,.577,0c0-.475.275-.6.729-.748.025.076-1.8-1.376-1.846-1.386C299.112,289.157,296.61,291.333,295.582,291.333Z",
    transform: "translate(-90.14 -209.478)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.844,326.222c0,.452.3.325.386.731h.269C324.474,326.352,324.241,326.222,323.844,326.222Z",
    transform: "translate(-91.751 -211.526)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.553,299.924a18.633,18.633,0,0,1-3.577.27l.115.077c.668.669,2.775.132,3.539-.193Z",
    transform: "translate(-90.573 -210.109)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.865,326.71l.153-.038v-.616c-.058,0-.107-.057-.153-.037C320.518,326.193,320.626,326.346,320.865,326.71Z",
    transform: "translate(-91.579 -211.515)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.911,301.567l-.038-.172c-.3-.07-.746-.646-1.078-.577a1.964,1.964,0,0,0-.307.153C301.867,301.614,302.133,301.615,302.911,301.567Z",
    transform: "translate(-90.547 -210.157)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.773,293.716c1.1-.524,3.994-.069,4.23-1.231a.857.857,0,0,0-.383.039c-.049.019-.01.106-.038.154C304.9,292.524,301.635,292.412,301.773,293.716Z",
    transform: "translate(-90.562 -209.708)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.051,286.059c-.309-.83-1.316-2.719-2.383-2.922-.052.555.18.615.653.615,0,.635-.1,1.9.847,1.73C303.712,286.519,304.558,286.059,305.051,286.059Z",
    transform: "translate(-90.61 -209.205)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.334,302.109a1.471,1.471,0,0,1,.077.23h.462a.485.485,0,0,0-.077-.423.764.764,0,0,0-.154.039C304.527,302,304.449,302.05,304.334,302.109Z",
    transform: "translate(-90.7 -210.217)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.775,300.125c-.57.045,1.391.153,1.77.153-.115.026-.142-.039-.078-.193A9.042,9.042,0,0,0,299.775,300.125Z",
    transform: "translate(-90.449 -210.117)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.123,295.887c0,.367.54.384.768.384a3.429,3.429,0,0,0,.078,1.5c.5-.336.515-1.575.423-2.076h.462a4.353,4.353,0,0,0-.038.652,4.209,4.209,0,0,0,.767.154c-.287.74-.128,1.189.732,1.153.14-.81-.716-2.158-1.078-2.73C306.8,294.925,301.123,292.839,301.123,295.887Z",
    transform: "translate(-90.527 -209.803)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.148,278.3c-.113.855.283,1.643,1.231,1.463,1.341-.325,3.279-.089,4.615-.539q-.507-.08-.307-.6C155.6,279.059,154.178,277.963,152.148,278.3Z",
    transform: "translate(-82.501 -208.941)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.455,299.666q-.238-.447-.847-.153a.347.347,0,0,0,.078.306A2.549,2.549,0,0,0,307.455,299.666Z",
    transform: "translate(-90.822 -210.081)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.814,310.818c-.924-.076-1.385-.135-1.385-1.153-3.068-.6-2.967-6.882-5.154-7.385a1.909,1.909,0,0,0-.077.462c-1.747,4.582-5.452,4.676-3.769.346a25.738,25.738,0,0,0-3.807-.828c.127.584.487.372.654.79-2.132.735-1.692,1.768-3.652,1.768-.02-.114-.069-.231-.079-.345-1.028.27-2.019,1.461-2.807,1.461a7.841,7.841,0,0,1,.308,1h-.673v-.5c-.979,1.164-5.8,3.315-6.174,4.423-.4-.056-.576-.107-.73-.462a3.3,3.3,0,0,0,.193,3.309,1.225,1.225,0,0,0-.808-.192,15.416,15.416,0,0,1,2.116,6.036c-.474,0-.82.205-.885.616,1.609,0,14.192-2.974,14.192-.731.9,0,1.543,2.686,2.46-.153.74.245-.027.75.077,1.384.307-.18.243-.3.654-.23-.017.448-.128.82-.153,1.269-.143.028,4.461,3.817,4.461,1.693,4.778.64,6.653-4.351,6.653-9.306l-.077-.039A25.21,25.21,0,0,0,324.814,310.818Z",
    transform: "translate(-90.297 -210.235)",
    fill: "#2ad193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.173,287.2c.009,0,0-.028-.009-.069C269.152,287.171,269.151,287.2,269.173,287.2Z",
    transform: "translate(-88.805 -209.42)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.466,275.85c.085-.028.156-.051.223-.07C262.506,275.58,262.418,275.576,262.466,275.85Z",
    transform: "translate(-88.444 -208.801)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.77,324.522a.829.829,0,0,0-.462-1.105c-.075.171-.155.289-.232.46a2.941,2.941,0,0,1-.634-.5c.012.181.02.379.02.608,0,.717.437.24.231,1.451h-.77a3.623,3.623,0,0,0,0,.731h.992v1.27h.662c.038-.7.809-.908.809-1.711h.537C347.107,324.371,347.7,324.2,345.77,324.522Z",
    transform: "translate(-92.832 -211.372)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.445,323.3c-.145-2.1-1.013-1.071,0,0Z",
    transform: "translate(-92.835 -211.303)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.631,246.257c-.328-.358-.461-.268-.461.211h.461C339.621,246.382,339.669,246.326,339.631,246.257Z",
    transform: "translate(-92.577 -207.206)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.184,236.024c.058.038-.028.26.038.269a8.134,8.134,0,0,0,2.192.307v-.307A4.984,4.984,0,0,0,355.184,236.024Z",
    transform: "translate(-93.44 -206.664)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.083,230.806c-.7-.551-2.686-1.894-3.784-1.894,0-2.116-6.933-2.054-7.615-1.346,1.1.454.268,1.026-.5,1.076v-.557H332.4v-.518a1.272,1.272,0,0,0,.9-.231l-.038-.152a2.075,2.075,0,0,0-1.345-.1c0,1.31-3.453.719-4.424.4a4.855,4.855,0,0,0,0,.886.33.33,0,0,1-.383-.039c-2.2-4.449-3.79-.725-7.653-2.961l.154-.154c-.515-.256-.566-.488-1.192-.462-.061-.294.113-.327.383-.461a4.041,4.041,0,0,0-2.345-.252c-.044.55-.406.813-.884.6.147-.309.333-.619.422-.845-.87,0-4.039-1.36-4.039-.078a2.793,2.793,0,0,0-1.191.078c0,.666.77.628.77,1.344a10.264,10.264,0,0,0-1.808-.288v.212c.329.081.516.282.384.615-1.476-.286-4.286-2.052-4.5.423H304.8c0-2.115-3.331-5.622-5.616-3.923a1.45,1.45,0,0,1,.386,1,25.821,25.821,0,0,0-7.635-.9v-.6c-.315.132-.96.441-1.25.153l.039-.153c1.872,0,.3-.6-1.537.077.162,1.009-1.521.922-2.425.922.708-.076,4.276-2.053,4.385-2.691h.768c.075-.615.464-2-.883-2a1.845,1.845,0,0,1-.02-.462,3.6,3.6,0,0,0-2.366.153.814.814,0,0,0-.883-.308v.463a.527.527,0,0,1-.616-.116c.189-.237.345-.3.345-.654-.588.01-1.122-.115-1.692-.115a1.1,1.1,0,0,1,.655-.537V216.1c-2.253-.392-2.376.635-3.693,1.309a.27.27,0,0,0,.231.23l-.038.184h-1.538c-.044.264-8.27,2.693-8.807,3.932-.659-.125-3.854.009-4.115.537a.875.875,0,0,0-1.078.232,4.86,4.86,0,0,0,1.885,2.038,27.183,27.183,0,0,0-4.191-.73l.038.152c.481.088.769-.04.769.5a6.93,6.93,0,0,0-1.013-.02,4.431,4.431,0,0,1-1.1-1.48.355.355,0,0,1-.307.077,10.148,10.148,0,0,1,0,1.174h-.652c0,3.542,2.441,3.009,2.768,5.1-1.279-.707-2.962-.9-2.962,1.723-1.494,0-1.3,1.114-3.191.422.731-1.085,3.115-.38,3.115-2.8-.972.081-1.115-3.405-1.116-4.414h.5l.01-.941a17.416,17.416,0,0,0-2.855.037c0,2.213-1.633,1.992-1.462,4.077,2.819,0,.346,3.117.346,1.116-2.167-.159-6.268-3.5-6.268-1.23,1.99,0,1.31,1.337.21,1.884a4.551,4.551,0,0,0,0-.922,5.91,5.91,0,0,1-2.979.722v.394c-.536.055-.5-.1-.846-.308a2.766,2.766,0,0,0,.192-.769c-1.234.74-3.507.733-4.576,1.769.512,1.011-1.844,1.491-1.731-.135h.847c-.314-1.164-1.059-1.239-2.27-1.239v.336a.607.607,0,0,1,.443.115c-.1,1.5.231,1.485.231,2.807a13.881,13.881,0,0,0-1.9-.307c0,.363-1.186.93-1.538.96.142.266.575.849.538,1.192-.82-.4-1.632-.13-2.384-.845-.8.457-.309.517-.115,1.115.542-.1.876.04.807.5-.965.267-2.307-.014-2.307-1.309h-.49c.129-1.428-.5-1.905-1.665-2.5l.04-.154c6.834,1.354,7.848-.572,1.192-2.731,0,.436-.227.471-.576.27.294-.6-.121-.415-.193-.961a3.828,3.828,0,0,1-2.038-.153v-.173h.5a1.62,1.62,0,0,0-1.538-.982v.462a2.921,2.921,0,0,1-.424.039c0-.382.153-.436.23-.75h-1.057a8.034,8.034,0,0,0,0,.943l-.212-.039c.095-.474.028-.728-.5-.693l-.008-.384c-.465.231-1.534.84-1.873.615a.392.392,0,0,1,.23-.27c-.8.077-2.228.691-.616.848v.345a13.534,13.534,0,0,0-1.576-.193c0,.438.077.559-.232.809,0-.553-.8-1.051-1.345-1,.057.646-.467,2.073-.653.846-.256.255-.219.272-.654.308a1.146,1.146,0,0,1,.269.963,7.392,7.392,0,0,0-.847-.271.532.532,0,0,0,0-.616,2,2,0,0,1-.23.079v.461a2.039,2.039,0,0,0-.768.153c.137.245.115.148.115.384a1.817,1.817,0,0,0-1.541.847c.676-.328,2.124-.931,2.847-.577l-.077.153a1.2,1.2,0,0,0-1.307,1.27c-.86,0-1.559,1.467-1.654,2.155l-.038-.155c-.467.232-.794.488-1.271.693l.039.191a4.607,4.607,0,0,0,.616,0c-.115.838-1.854,1.361-2.384,1.384a.606.606,0,0,0,.078.577,3.2,3.2,0,0,0-2.77,3.154.663.663,0,0,1,.808.191,1.44,1.44,0,0,0-.462.962c.24,0,.375,0,.616.018-.032.43-.262.492-.194.906,1.646,0,2.04-.692,3.462-.924v-.308c.8.141,1.75,3.5,1.884,4.31h1.078c.073-.731.945-.849,1.537-.849v-.462h.615a.476.476,0,0,0,0-.384.74.74,0,0,1-.769-.153c.418-.659,1.941-2.367,1.847-3-.258,0-.516-.01-.768-.01,0-1.254,3.162-7.91,4.421-6.221.637-.245.92-.032.886.808h-.462c0,1.534-2.308,2.084-2.308,4.615a28.623,28.623,0,0,0,6.422.536l.077.155c-1.356,1.355-5.234.343-5.845,1.383.171.078.289.16.463.233a2.894,2.894,0,0,0-.962.23c.21.529,1.846.354,2.538.807-.384.481-.636.213-.693.846-.567-.017-1-.336-1-.846a2.523,2.523,0,0,0-1.115,2.693l-.077.153c-.377,0-2.134-.419-1.115.5l-.038.153c-.647-.048-4.115.127-4.115-.307a4.534,4.534,0,0,1-1.52.184,2.521,2.521,0,0,1,0,.47c-.486.107-.691-.067-.788-.5a.526.526,0,0,1-.461.077,1.247,1.247,0,0,1,.038-.577,8.28,8.28,0,0,0,1.625.231,6.952,6.952,0,0,0,.183-1.461c-.416.07-1.123.467-1.384.385.027-.346.185-.455.231-.807a.655.655,0,0,1-.461,0c.36-2.792-2.355.644-1.231,1.23a3.08,3.08,0,0,0,.114,1.885c-1.558.127-2.52.856-3.768.856v.3l.307.152v.5c-.791,0-1.113.73-1.961.73v.924a3.448,3.448,0,0,0-.885.114v.463c-.678.015-1.237-.421-1.653-.387v.464c.115.048.191.077.307.114a.812.812,0,0,0-.088.184c1.02.96-5.759,8.093-4.8,5.239h-.77l-.076.154c.94,1.178.03,3.776.114,5.231a2.814,2.814,0,0,1,2.732.961l.077-.194-.153-.037c1.382-.49,2.7-1.578,4.153-1.692-.472-1.841.468-2.645,2.384-2.808-.232-2.3.836-1.355,2.5-1.355,0-2.442,7.035,2.288,6.77,3.971-.875,0-1.62.317-2.615.317a1.968,1.968,0,0,0,2.191.952v-.578c.9-.141.767-.992,1.537-1.268a2.557,2.557,0,0,0,0-.482h-.654a1.235,1.235,0,0,1,.039-.4c.486.038,1.02.27,1.385.27a1.035,1.035,0,0,1-.2-.619,3.159,3.159,0,0,0,1.816,1.158v.614h-.385c-.1-.26-.024-.161-.307-.115a2.29,2.29,0,0,0,.692.845c.124-.149.221-.236.346-.384.36,1.975,1.467.43,2.422.308,0-.2.019-.387.019-.577a1.011,1.011,0,0,0,.482-.038.749.749,0,0,0-.615-.462.657.657,0,0,1,0,.462c-.456,0-1.411-1.422-1.269-1.731a1.064,1.064,0,0,0,1.229.191.257.257,0,0,0-.269-.191c.676-1.012,1.618.222,2.077.462.023.218,1.027,5.048,1.134,2.652a11.473,11.473,0,0,0,4.3.635,3.674,3.674,0,0,1,0-.669c.42.092.971.389,1.3.093,3.208,1.76-3.44,4.4-3.52,4.442a2.249,2.249,0,0,0,.826.23,3.04,3.04,0,0,1,.154,1.153c.962,0,.522,2.068,1.73.847,2.752,5.052,5.324,10.692,9.654,11.575a5.766,5.766,0,0,1,3.23-1.538c0-.926,1.348-1,2.116-.805,0-.675.134-1.014,1-.849.1-.6.3-.749.845-.749.076-.7.343-1.046.923-.827,0-1.079.026-1.13.808-1.461-.085-.537-1.058-1.322-1.577-1.5.09-.52.147-.8-.538-.769a.5.5,0,0,1-.231.613,4.449,4.449,0,0,0-.615-1.767,1.793,1.793,0,0,0-.615,1.384c-1.525-.123-3.965-.105-1.115-.577-.084-.358-1.921-.456-2.309-.461-.151-.223-2.368-3.193-1.308-3.576.249-.095,14.138,6.454,14.038,5.346a16.23,16.23,0,0,0,1.731.653,2.183,2.183,0,0,0-.7.085c1.116,1.213,5.858,9.912,6.114,10.73.243-.822,6.933-9.5,6.968-9.969a5.313,5.313,0,0,0,2.808-.462v-.462c.759.073,1.961,2.495,1.961,3.23,1.36,0-.119,2.16,2.271,1.617-.048-.225.036-.276.115-.462,1.212.258,1.515,8.369,3.457,11.121-.863.187-2.647-1.616-2.919-2.315-.184,0-.395.175-.577.154-.422,0-.666-.436-1.077-.384.473,2.9,5.454,5.437,6.615,8.346,1.561-.506.833-1.59,2.115-1.962-.072-.392-.234-.469-.578-.576a.245.245,0,0,1,.154-.308c-.279-.361-.9-.479-1,.078h-.423a1.279,1.279,0,0,1,0-.616c-.763-.457-1.343-.038-1.154-1.385-.824,0-.838-.326-1.062-.9a1.557,1.557,0,0,0,2.063.6,7.093,7.093,0,0,1-1-3.654c-1.343,0-2.439-1.894-2.768-2.731a8.91,8.91,0,0,1,.846-2.807c1.9.785,2.491,2.648,3.346,4.116,1.985-2.936,2.806-1.651,2.806-5.807-2.832,0-2.463-4.413.694-4.413-.829,1.3-1.236,2.375.575,2.414.063-.46.472-1.121-.058-1.309v-.921c3.3,0,9.144-6.794,7.884-6.884v-.615h.289c-.329-1.988-1.278-2.6-1.153-4.347a3.638,3.638,0,0,1,1.846-.5.7.7,0,0,0,0-.519H297.8c-.225-.383-.318-.6-.885-.442a4.759,4.759,0,0,1-.115.6h-.48v-.866c.1-.579.421-3.2,1.21-.616,2.2-1.23,2.58-.958,2.732.962,1.538.177,1.688,1.421,1.077,3,1.657,0,2.665-.737,2.73-2.23-.915,0-2.265-2.652-.155-2.846a72.252,72.252,0,0,0,8.5-10.729c1.412.84.289,4.242.289,5.614.479-.019.542-.273.748-.693.333.32.047.578.769.615-.3-1.945-1.462-2.146.539-2.768-.311-1.893-1.035-3.377-1.193-5.23h-.307v1.116a.482.482,0,0,0-.422.077,7.583,7.583,0,0,1,.115.923,3.817,3.817,0,0,0-2.308-2.116v.77h-.654a1.461,1.461,0,0,0-.385-.809l-.192.039a1.728,1.728,0,0,1,0,.616.4.4,0,0,1-.347-.077.706.706,0,0,0-.153-.885c-.292.3-.455.218-.807.153.049-.569,1.415-1.461,2-1.461,0-2.661,4.006-3.462,5.807-3.462.744,0,1.527-.18,2.308-.114a.776.776,0,0,1,.231-.771,9.546,9.546,0,0,0,1.423.578c-.457,1.135,1.346.091,1.923.538a.355.355,0,0,1,.077-.307,1.166,1.166,0,0,0,.769.153c-.038-.169-.111-.27-.155-.442a1.3,1.3,0,0,1-.46,0c.743-1.657,2.4-3.057,4.115-2.327-.271.4.075.523.075,1a3.032,3.032,0,0,0,2.31-2.152c.487,0,.86-.113,1.383-.115-3.151,2.908-4.665,8.121-6.844,10.307a1.845,1.845,0,0,1,.4,1.884c.334,0,.661-.194,1.059-.194,0-1.436,2.31-2.786,3.116-3.037-.41-1.222-.2-1.881.961-1.537-.217-.34-.769-1.6-.154-1.807a.276.276,0,0,0-.115-.308c-.273.056-.24.124-.577.154.157-2.214,1.572-2.028,2.614-2.653a1.928,1.928,0,0,1,.27.422c1.2-.236,1.006-1.028,2.693-.616,0,.374-.046.644.384.731,0-2.645,5.5-2.819,6.845-3a14.229,14.229,0,0,1-.73-1.923c-.106,0-1.659-.752-1.8-.775,1.436-1.182,3.148.8,2.992-1.762.5-.038,2.845.975,2.845,1.574.905.533,1.929.972,2.117-.037a1.545,1.545,0,0,0,.422-.038c0-.4-.157-.758.153-1C348.588,233.8,347.885,229.8,345.083,230.806Zm-118.024-4.144v-.674a5.06,5.06,0,0,1,.519-.008v.682Zm-7.9,29.67c.178-.981-.923-.67-.923-1.578a2.064,2.064,0,0,0-.691-.018c2.386-.943,2.977,1.343,4.225,2.945C220.753,257.472,220.2,256.486,219.157,256.332Zm47.111-30.458a4.453,4.453,0,0,0-.676-.81C265.964,225.29,266.31,225.566,266.267,225.874Z",
    transform: "translate(-85.169 -205.589)",
    fill: "#2485ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.007,297.929a1.161,1.161,0,0,1,.078.5c0,.313.75.727.96.693-.182-.482-.729-.777-.729-1.231A.635.635,0,0,0,329.007,297.929Z",
    transform: "translate(-92.029 -209.999)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,252.311c.226.373.981.329,1.386.307a.7.7,0,0,1-.012-.47C207.362,251.976,206.936,252,206.17,252.311Z",
    transform: "translate(-85.412 -207.53)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.032,300.9a2.084,2.084,0,0,0,.038.269c.219.328.458.231.732.115C333.663,300.9,333.445,300.842,333.032,300.9Z",
    transform: "translate(-92.246 -210.161)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.917,241.389c-.534-.184-.906,0-1,.557a1.338,1.338,0,0,0,.491,0C336.7,241.946,336.9,241.594,336.917,241.389Z",
    transform: "translate(-92.402 -206.952)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.916,250.535a3.19,3.19,0,0,1-.461.884,1.123,1.123,0,0,0,.654-.884Q329.984,250.434,329.916,250.535Z",
    transform: "translate(-92.054 -207.446)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.438,327.036v.73c-.687.919-2.533,3.158-3.96,3.423a1.524,1.524,0,0,0,1.77,1.192c.3,0,.432-.425.922-.425a2.434,2.434,0,0,1,2.115-2.192c-.169-.355.59-1.588.77-2.229C343.235,327.535,343.265,326.977,342.438,327.036Z",
    transform: "translate(-92.54 -211.569)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.446,309.6a3.112,3.112,0,0,0,2.345,1.769C338.679,310.675,336.945,309.786,336.446,309.6Z",
    transform: "translate(-92.43 -210.63)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.317,333.089a1.079,1.079,0,0,0-.27.289h.615a.674.674,0,0,0-.038-.326C339.577,333.1,339.364,333.052,339.317,333.089Z",
    transform: "translate(-92.57 -211.894)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.531,246.335c-.142-.431-.105-.7-.5-1,0,.4.081.77.114,1.174h.462C338.588,246.449,338.55,246.394,338.531,246.335Z",
    transform: "translate(-92.516 -207.169)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.867,294.839c-.139-.046-.216.006-.232.155a1.886,1.886,0,0,0,1.076.114c-.16.025-.185-.083-.076-.326A4.251,4.251,0,0,0,305.867,294.839Z",
    transform: "translate(-90.77 -209.832)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.494,292.485a.351.351,0,0,0-.077.209c.2.325.538.442.692.792A.923.923,0,0,0,284.494,292.485Z",
    transform: "translate(-89.627 -209.709)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.756,291.565a.266.266,0,0,0-.192-.259c0,.363.023.615.422.656l.039-.155C283.919,291.73,283.756,291.7,283.756,291.565Z",
    transform: "translate(-89.581 -209.645)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.414,292.8a.351.351,0,0,1,0-.1.567.567,0,0,1-.039-.056Z",
    transform: "translate(-89.625 -209.717)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.229,286.1c-.684.827-.293,2.62,1.018,2.539,0-1.087-.717-1.6-.788-2.5Z",
    transform: "translate(-88.899 -209.365)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.538,300.355a1.6,1.6,0,0,0-1.923-.75c.068-.53.433-.274.845-.519a25.3,25.3,0,0,0-6.5-.345v.192h.463v.346c1.549,0,3.079.81,4.692.923a.356.356,0,0,1,.078-.308A8.156,8.156,0,0,0,298.538,300.355Z",
    transform: "translate(-89.98 -210.041)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.988,269.725c-.918-2.169-6.686-2.276-9.074-2.808,0,.738.037,1.207,0,1.961a13.751,13.751,0,0,1-3.616-.615c-.184-.555-3.826-3.859-3.923-3.923.378-.313.336-.364.847-.461-.629-1.05-3.234-.408-4.077.153-1.048-.848-2.946-.558-4.23-.077-.516,1.509-3.089,1.068-4.231.461a3.054,3.054,0,0,0-.307,1.422h-1.153v1.269h-1.153c-.084.949-.231,1.818-.309,2.769h-.922c-.031.653-3.292,4.328-3.924,4.385a4.489,4.489,0,0,1-.922,2.767,2.408,2.408,0,0,1,1.461.385c-.982,2.228-1.3,6.876,1.923,7.384,0,1.223.646,1.757,1.923,1.846.485,2.993,12.39,1.253,15.152,2.078.07,1.4-.168,3.463-1,4.307,7.2,2.345-.289,12.12,4.077,14.691,0,3.707,3.3,6.8,2.692,9.843a1.263,1.263,0,0,0,.615.078c0,1.538,4.165.835,5.307.539.813-1.881,6.339-3.034,4.845-6.69,5.05-2.182,3.124-10.389,5.077-14.132,2.2-4.216,7.4-8.867,8.307-13.866C235.372,282.475,237.962,277.14,231.988,269.725Z",
    transform: "translate(-84.81 -208.137)",
    fill: "#2ad193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.358,297.874l.153.115c-.012-.146-.025-.276-.038-.422A.275.275,0,0,0,288.358,297.874Z",
    transform: "translate(-89.839 -209.982)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.753,294.192a.276.276,0,0,0-.077.231,3.169,3.169,0,0,0,1.384,1.886v-.615C286.348,295.32,286.227,294.393,285.753,294.192Z",
    transform: "translate(-89.695 -209.8)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.639,303.337c0,3.1-3.846,4.963-3.846,9.731a4.408,4.408,0,0,0,4.538-4.5C247.331,307.109,248.444,304.058,246.639,303.337Z",
    transform: "translate(-87.385 -210.293)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.922,279.027c.388.515.687.322,1,.849a.488.488,0,0,0,.616-.309A1.382,1.382,0,0,0,147.922,279.027Z",
    transform: "translate(-82.275 -208.98)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.874,300.325c-.587-.287-3.018.16-2.773,1.049C305.6,301.573,307.624,300.573,307.874,300.325Z",
    transform: "translate(-90.741 -210.126)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,294.961a3.768,3.768,0,0,1-.019.461c-.378,0-.677-.03-.866-.346a1.9,1.9,0,0,1,.423-.307,5.023,5.023,0,0,0-2.98-1.077v.73h-.634c.08-.479.467-.729.5-1.114-.543-.046-.887-.344-1.462-.272,0,.476-.052.712-.615.655a6.138,6.138,0,0,0,.01-.616c.907,0,.766-.73.721-1.481h-.5c-.8-1.4-5.637-3.651-5.637-4.258-.67-.072-1.5-.7-1.5-1.346-.664.356-1.105.342-1.155-.384a.44.44,0,0,0,.346-.153c-.259-.344-3.645-.086-4.615-.27v-.463c-.548,0-.9-.357-1.46-.461,0,.338-.707,1.658-.885,2.309a1.649,1.649,0,0,1,.23-2.539l-.077-.152c-.584-.1-.846.1-.846.654a14.329,14.329,0,0,1-2.538.577c.227.861-.066,1.153-.769,1.153,0,.6-1.5,1.677-.588,1.8,0,.929.524,2.988-.846,3.116a1.446,1.446,0,0,0,.076.537q-.565.081-.5.578c-.54.092-.693.33-.693.921h-.655c.056.53-.15,1.111.115,1.578a1.086,1.086,0,0,1,.731-.115c.008.53-.273.56-.731.615,0,2.325,3.444,11.346,7.683,11.346-.221,6.807-2.414,13.021-2.414,19.075-1.223.095-.573,1.2.154,1.423l.115-1.386h.577a12.354,12.354,0,0,0-.711,3.347c-.479-.231-.4-.445-.482-.923q.038.192-.231.077a3.569,3.569,0,0,1,.5,1.537l-.115-.077c-.471-.1-.173-.46-.652-.46v.46c-1.122.2.069.638.384.847-.115.288-.173.3-.115.615a1.048,1.048,0,0,1,.73.192.36.36,0,0,0-.077.309c-2.139,0-1.045,1.771-.654,2.729l-.307.155.077.191a1.673,1.673,0,0,1,.614,0c.011.211-.1.326-.345.346a2.306,2.306,0,0,0,.576.385l-.153.115c.468.594,1.369,1.159,1.462,1.923,1.633.1,3.072.719,4.884.6-.076-.468-.946-.52-1.383-.52v-.346c-1.11,0-1.371-2.952-1.309-3.865h.769c0-.842,1.128-2.047,1.654-2.673-2.025-.218-1.627-1.441.077-1.923a14.45,14.45,0,0,1,1.269-2.807c-.253.043-.379.187-.615.229a1.786,1.786,0,0,1-.352-1.325,4.985,4.985,0,0,0,1.847.345,10.95,10.95,0,0,0,.038-1.961c2.167.381,3.69-.362,4.308-2.345a.61.61,0,0,1-.307-.04c-.138-.741-.834-.869-.961-1.5,3.734.989,4.045-3.143,5.345-2.962-.1.31-.16.33-.077.615,3.959-1.953.779-5.529,6.77-6.613.286-2.667,2.52-4.3,2.23-7.768C182.924,301.472,178.215,294.317,173.46,294.961Z",
    transform: "translate(-82.166 -209.243)",
    fill: "#2ad193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.078,226.433l-.154-.078c-.922.7-2.172,0-2.692-.846.576-.048,1.125.043,1.5-.462,1.259.5.2.87,2.116.5a3.791,3.791,0,0,0-1.692-2.269c.277-.23.747.213,1.269.213.159-1.29-.133-1.65-1.461-1.134.183-.275.35-.246.461-.5a2.239,2.239,0,0,1-.461-.193.571.571,0,0,1,.768-.114v.422a4.019,4.019,0,0,1,1.371-.449,1.569,1.569,0,0,1-.447-.589c-.155-.307,2.16-.35,2.346-.654-.609-.6-.867-.418-.867-1.4a4.916,4.916,0,0,0,.635,0,12.29,12.29,0,0,1-.345-1.252c-1.791,0-.583-1.952.577.348l.193-.078c.669-1.756.133-1.9-1.232-1.9v-.482a1.679,1.679,0,0,0,.922-.114c-.282-.43-1.14-.5-1.653-.461a.48.48,0,0,1-.077.422c-.57-.11.09-1.3.153-1.808h.462c0-.589.414-.521.808-.691-.205-1.235,1.626-1.488,2.383-2l-.039-.183a4.109,4.109,0,0,1-1.807-.087c.463-.1,5.126-1.032,4.191-1.962-1.862-1.876-6.684,2.113-8.305,1.885.326-.4.52-.763,1.018-.96a1.976,1.976,0,0,1-.019-.5c1.73-.844-1-.855-1.385-.912v.77a9.675,9.675,0,0,0-1.692.3c.15-.817.726-.49,1.308-.767l-.038-.155c-1.858-.293-3.9.738-5.576.5.513-1.365,6.57-1.325,8.306-1.537V206.9a5.427,5.427,0,0,1-2.268-.191q.265-.081.076-.27a59.274,59.274,0,0,0-6.114-.02l.039-.172c.358.123.681.076.807-.289h4.614c-.191-1.347-8.316-1.139-9.5-.211.4.521-4.894.144-6.058.6.238.5.827.283.827.98-1.2-1.977-1,1.327.463,1.327-1.619,0-2.84-1.3-4.559-1.3,0,.265,1.036,1.122,1.212,1.548a13.188,13.188,0,0,0-2.826-1.326c.815,0-4.763-.891-2.384,1.633-1.733-.941-3.2-1.307-3.452.6-.674-.1-4.638.241-4.508,1.634,1.121.363,1.744-.343,1.826,1.055,0,.958-2.365.439-2.845.676,0,.449-3.308.766-2.924,1.384a4.152,4.152,0,0,0,.346.423,10.015,10.015,0,0,0,4.25.451c-.68,1.063-1.288.455-2.558.644,0,.077-.009.116-.019.192-1.057.4.106.667.923.885-.212,0-.241,0-.308.155.388.313,1.154.975,1.712.75-.363-.748.424-.231.886-.231v-.155c3.687-.389,6.985,1.36,7.326,5.221h.37v.318c-.55,0-.251.322-.332.692h-.289c.224.626.835.824,1.654.653a.335.335,0,0,1,.077-.325H167c.061.555,1.027,1.189,1.346,1.519-.737-.152-2.024-.565-2.731-.269.125.372.346.413.346.729-1.7.139,1.137.77,1.6.77v-.538c-.459,0-.593-.168-.98-.232l.077-.153c1.49.017,2.072.681,1.923,2.039a8.687,8.687,0,0,1-1.519.211v.751c-1.979-.253-.22,1-.135,1.5-1.682.311.972,1.055,1.039,1.077,0,1.571-.916.983.73,1.154,1.133,8.653,4.943,2.307,6.653,2.307,0-.52.127-.618.578-.807-.273-1.826.516-1.27.729-2.5h.942a1.69,1.69,0,0,1,0-.577h.537a2.37,2.37,0,0,0,0,.644c2.3-.181,2.644-2.749,4.03-3.326C183.6,228,188.147,228.856,189.078,226.433Z",
    transform: "translate(-82.512 -204.996)",
    fill: "#2485ff",
    opacity: 0.554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.952,233.527a4.907,4.907,0,0,0,.078-1,37.7,37.7,0,0,1-4.769.845c.1-.452-.073-.55-.232-.922l-.307.078v.307c-.825-.273-1.691-.185-1.691.769.114-.019.211.02.307,0,.712-.114.949-.094,1.153.617a4.349,4.349,0,0,0-1.537,0l.077.46a5.583,5.583,0,0,1,1,0,1.043,1.043,0,0,0,.155.923c2.872.377,3.811-1,6.537-1C197.884,233.818,197.579,233.634,196.952,233.527Z",
    transform: "translate(-84.539 -206.475)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.254,222.463c.318.232.458-.028,0,0Z",
    transform: "translate(-84.663 -205.936)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.715,281.683c-.246.515.14.713.615.654.411-.655,1.278-3.346-.447-3.346h-.369C302.514,279.925,301.517,281.409,302.715,281.683Z",
    transform: "translate(-90.581 -208.982)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.962,275.831c0,.369,6.956,1.7,7.694,1.806C150.14,276.8,142.962,274.179,142.962,275.831Z",
    transform: "translate(-82.007 -208.783)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645,273.846a1.884,1.884,0,0,1,.04-.221c-1.222,0-1.555,1.473-1.346,2.5h.463C302.8,275.183,303.645,274.716,303.645,273.846Z",
    transform: "translate(-90.59 -208.693)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.643,293.956c.43-.437-.177-.994-.576-.193A.57.57,0,0,0,310.643,293.956Z",
    transform: "translate(-91.009 -209.755)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.939,295.156l-.078-.154a1.347,1.347,0,0,0,.039.4,2.708,2.708,0,0,1,.48,0v-.481h-.441Z",
    transform: "translate(-90.998 -209.84)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08,295.057c-.347-.6-1.421-2.079-2.345-.576l.115-.233a.587.587,0,0,0-.5.155l.038.154C311.411,294.756,311.94,295.565,313.08,295.057Z",
    transform: "translate(-91.024 -209.781)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.073,301.413l-.089-.147A.157.157,0,0,0,305.073,301.413Z",
    transform: "translate(-90.735 -210.181)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.372,299.232q-.693.107-.577.73a.9.9,0,0,0,.039.155C311.542,300.136,311.658,299.823,311.372,299.232Z",
    transform: "translate(-91.047 -210.072)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,296.084v-.153a.244.244,0,0,0,.038.308c.747-.05,1.361.229,2.04.229a1.785,1.785,0,0,1-.022-.46C309.885,295.932,308.6,295.47,308.4,296.084Z",
    transform: "translate(-90.917 -209.885)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.105,301.466c0-.01,0-.019,0-.028s-.014-.012-.023-.017Z",
    transform: "translate(-90.74 -210.19)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.812,294.212a2.883,2.883,0,0,0-.519,0,3.111,3.111,0,0,1,.078.827h.767v-.194h-.325C314.829,294.625,314.812,294.426,314.812,294.212Z",
    transform: "translate(-91.237 -209.801)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.055,302.709V302.4a5.328,5.328,0,0,0-1,0l.152-.037C309.239,302.53,310.719,302.734,311.055,302.709Z",
    transform: "translate(-90.999 -210.241)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.769,294.208a1.191,1.191,0,0,0,.634,0,2.113,2.113,0,0,0,0-.808,4.863,4.863,0,0,1,.77,0c.039-.416-.193-.522-.193-.923a.635.635,0,0,0-.461,0,2.49,2.49,0,0,0,.192-.845A3.443,3.443,0,0,0,307.769,294.208Z",
    transform: "translate(-90.885 -209.663)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.414,297.914a.531.531,0,0,1,.02.384c1.094,0,2.882.264,2.634-1.422-.972.15-1.114.768-2.577.768C324.491,297.7,324.414,297.856,324.414,297.914Z",
    transform: "translate(-91.782 -209.945)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.577,266.679a7.815,7.815,0,0,0,.885,0c0,.784-.887,1.007.308,1.4,0-.961.5-1,.5-2.018a1.533,1.533,0,0,1-.5,0c.267-.808,2.194-.8,3-.943a4.226,4.226,0,0,1-1.962.462v1.039a5.075,5.075,0,0,0,1.886-1.076c.385.858.589.076,1.231.076a1.263,1.263,0,0,0-.04-.616c1.206-.314,6.589-5.708,2.731-6.422v-.23c1.041-.113,1.406.252,2.345.307a1,1,0,0,0,.011-.616c.724-.185,3.682-1.28,3.682-2.383-2.288.438-2.49,1.535-5.039.077-.108.7-.575,1.651-.575,2.231-.242,0-.244.061-.385-.231-.212.361-.894,2.016.23,1.5v.384h-.577a3.983,3.983,0,0,1-1.192,3.154,5.341,5.341,0,0,0,0-.615c-.177.166-.165.211-.192.536h-.576v.617c-.376.05-.4-.149-.347-.5l-.152-.038a1.465,1.465,0,0,0-.154.653.9.9,0,0,1-.443.04v.922c-.454-.052-.447-.221-.827-.385-.551.957-2.27-.337-2.27,1.326h-.7a.852.852,0,0,0,.008.482C309.9,265.813,309.67,266.163,309.577,266.679Z",
    transform: "translate(-90.983 -207.725)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.605,297.77c-.058.038-.1.076-.154.114C311.9,298.935,314.639,298.831,313.605,297.77Z",
    transform: "translate(-91.165 -209.993)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.58,299.793c-.089-.7,4.229,1.7,4.229.077,2.018,0,3.313,2.016,5.423,1.807a1.859,1.859,0,0,0-1.96-1.384v-.98a4.846,4.846,0,0,0-.674,0v-.731a3.914,3.914,0,0,1,.6,0c-2.96-3.1-7.792-3.82-11.422-2.866v.307c.358.171.307.268.307.654h.232c.018-.047-.039-.134,0-.153C315.313,295.077,315.58,299.052,315.58,299.793Z",
    transform: "translate(-91.101 -209.861)",
    fill: "#3757a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.914,254.887c-.317.062-.485.273-.767.424C325.616,255.591,325.75,255.3,325.914,254.887Z",
    transform: "translate(-91.821 -207.683)",
    fill: "#3757a2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.394,308.2",
    transform: "translate(-84.132 -210.555)",
    fill: "#3757a2"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4606.868 460.146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    fill: "none",
    stroke: "#eeebff",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    transform: "translate(0 7.131)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    transform: "translate(0 14.263)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    transform: "translate(0 21.394)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    transform: "translate(0 28.525)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    transform: "translate(0 35.657)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("line", {
    x2: 134.861,
    transform: "translate(0 42.788)",
    fill: "none",
    stroke: "#eeebff",
    strokeMiterlimit: 10,
    strokeWidth: 0.111
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.759 48.262)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(19.818 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(37.412 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(55.617 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(73.824 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(92.029 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(109.623 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(128.441 1)",
    fill: "#eeebff",
    fontSize: 1,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.775,
    y: 0
  }, "000")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.12 3.036)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.383)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.222)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 36.938)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 34.097)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 31.255)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 28.414)",
    fill: "url(#kr)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 25.572)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 22.731)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 19.89)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 17.048)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 14.207)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 11.366)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 8.524)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 5.683)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    transform: "translate(0 2.841)",
    fill: "#b2c6d9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.298,
    height: 1.112,
    fill: "#b2c6d9"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopImage);
export default __webpack_public_path__ + "static/media/desktop-image.12cd73164b965b371e5a5f7a7560e9df.svg";
export { ForwardRef as ReactComponent };